import React, { useRef, useState, useEffect } from "react";
import Header from "../components/Frontend/Header";
import Footer from "../components/Frontend/Footer";
import AsianStudent from "../assets/images/public-pages/asianStudent.png";
import ListeningStudent from "../assets/images/public-pages/student-listening.png";
import CourseVideo from "../assets/Video/promo_video_la_2025_v1 (1080p).mp4";
import ImmigrationSecond from "../assets/images/public-pages/immigration-test.png";
import VideoTestimonial from "../components/Frontend/VideoPTETestimonial";
import { Helmet } from "react-helmet";
import ReactGA from "react-ga";
import ReactPixel from "react-facebook-pixel";
import API from "../api";
import { store } from "store/index";
import { setAlert } from "action/index";
import { Button, Dropdown } from 'react-bootstrap';
import { getCountryForTimezone } from "countries-and-timezones";
import BuyBtn from "components/VideoCourse/BuyBtn";
import Plans from "components/VideoCourse/Plans";
import { Link, useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import RazorPay from "components/Payments/Razorpay/RazorPay";
import ReactHtmlParser from "react-html-parser";
import Slider from "react-slick";
import CrackedCodeSlider from "../components/Frontend/Sliders/CrackedCodeSlider";
import TestimonialSection from "components/PublicPagesReusable/TestimonialSection";
import "assets/css/video-course-section.css";
import FameWallNaati from "components/Frontend/FameWallNaati";
import BannerSection from "components/PublicPagesReusable/BannerSection";
import BannerHeader from "components/PublicPagesReusable/BannerHeader";
import ReusableHomePageSlider from "./ReusableHomePageSlider";
import '../assets/css/public-pages.css'
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Frame1 from "../assets/images/public-pages/Scorecard-vc-frame1.jpg"
import Frame3 from "../assets/images/public-pages/Scorecard-vc-frame3.jpg"
import Frame4 from "../assets/images/public-pages/Scorecard-vc-frame4.jpg"
import Frame5 from "../assets/images/public-pages/Scorecard-vc-frame5.jpg"
import Frame6 from "../assets/images/public-pages/Scorecard-vc-frame6.jpg"
import AiPower from "components/PublicPagesReusable/AiPowerSection";
import ButtonComp from "components/PublicPagesReusable/ButtonComp";
import FaqSection from "components/PublicPagesReusable/FaqSection";
import SkillAreas from "components/PublicPagesReusable/SkillAreas";
import Filter from "../assets/images/public-pages/filter.svg"
import Reward from "../assets/images/public-pages/reward.svg"
import Report from "../assets/images/public-pages/report.svg";
import CheckList from "../assets/images/public-pages/check-list.svg";
import SkillCard from "components/PublicPagesReusable/SkillCard";
import PteAppBanner from "components/PublicPagesReusable/PteAppBanner";
import TestSection from "components/PublicPagesReusable/TestSection";
import VideoCourseImage from "../assets/images/public-pages/VideoCourseImage.jpg"
import LeftStudent from "../assets/images/public-pages/vc-left-student.png"
import RightStudent from "../assets/images/public-pages/vc-right-student.png"
import AppBannerCustom from "components/PublicPagesReusable/AppBannerCustom";

const VideoCourse = () => {
  const sectionRef = useRef(null);
  const [plans, setPlans] = useState([]);
  const [corePlans, setCorePlans] = useState([]);
  const [country, setCountry] = useState("AU");
  const [activeTab, setActiveTab] = useState("la_acedemics_tab");
  const [paymentSetting, setPaymentSetting] = useState([]);
  const [selectedPlanId, setSelectedPlanId] = useState(null);
  const [showPaymentOptions, setShowPaymentOptions] = useState(false);
  const [selectedPaymentMethod, setSelectedPaymentMethod] = useState("");
  const token = useSelector((state) => state.token);
  const activeSubscription = useSelector((state) => state.user?.active_subscription);
  const navigate = useNavigate();
  const images = [
    {
      src: Frame1,
      alt: "score-1",
    },
    {
      src: Frame3,
      alt: "score-2",
    },
    {
      src: Frame4,
      alt: "score-3",
    },
    {
      src: Frame5,
      alt: "score-4",
    },
    {
      src: Frame6,
      alt: "score-5",
    },
    {
      src: Frame1,
      alt: "score-6",
    },
    {
      src: Frame3,
      alt: "score-7",
    },
    {
      src: Frame4,
      alt: "score-8",
    },
  ];
  const handleBuyNowClick = (plan, e) => {
    e.preventDefault();
    if (token) {
      navigate("/admin/sub/payment/form/" + plan.id);
      return;
    } else {
      navigate("/auth/login");
    }
  };

  const startCheckout = async (id, e) => {
    const data = { id, platform: activeTab === "la_acedemics_tab" ? "la_acedemics_tab" : "la_pte_tab" };

    const baseUrl = import.meta.env.VITE_URL_ALT + "/api/v2/";
    let message = "Something went wrong";
    try {
      let response = await API({
        url: baseUrl + "createCheckoutSessionWithoutLogin",
        method: "POST",
        data,
      });

      if (response.status === 200) {
        window.location.href = response.data.checkout_url;
        return;
      }
    } catch (error) {
      message = error;
    }

    store.dispatch(setAlert({ flag: true, type: 2, message: message }));
  };

  const redirectAfterPayment = (plan) => {
    const currency = country === "IN" ? "INR" : "AUD";
    navigate(
      `/pay-success?p=${plan.razorpay_price}&currency=${ReactHtmlParser(
        currency
      )}&mode=razorpay`
    );
  };

  const handleTabClick = (tab) => {
    setActiveTab(tab);
    setSelectedPlanId(null);
    setShowPaymentOptions(false);
    setSelectedPaymentMethod("");
  };

  const handleUpgradeClick = () => {
    if (!selectedPlanId) {
      store.dispatch(setAlert({ flag: true, type: 2, message: "Please select a plan first." }));
      return;
    }
    setShowPaymentOptions(true);
  };

  const handlePayClick = () => {
    if (!selectedPaymentMethod) {
      store.dispatch(setAlert({ flag: true, type: 2, message: "Please select a payment method." }));
      return;
    }
    const currentPlans = activeTab === "la_acedemics_tab" ? plans : corePlans;
    const selectedPlan = currentPlans.find((p) => p.id === selectedPlanId);
    if (!selectedPlan) return;

    if (token) {
      navigate("/admin/sub/payment/form/" + selectedPlan.id);
      return;
    }

    if (selectedPaymentMethod === "card") {
      startCheckout(selectedPlan.id);
    }
  };

  const blueBoxText = () => {
    return (
      <div className="light-blue-box">
        Unlock your PTE potential with our comprehensive video
        course, featuring proven strategies, expert insights, and
        step-by-step guidance from Australia's most successful PTE
        trainer. <br />
        <br /> Available exclusively with our Gold package - the
        complete preparation system that transforms your PTE
        performance.
      </div>
    );
  };
  const styleCards = [
    {
      title: "Expert Instruction",
      text: "Learn from 6+ years of teaching excellence and unparalleled PTE mastery. Varun's personal journey from student to perfect scorer to Australia's most trusted PTE trainer.",
      color: "#141414",
      img: Report
    },
    {
      title: "Proven Strategies",
      text: "Access the exact methods that have consistently delivered 79+ scores. These aren't theoretical approaches - they're battle-tested techniques refined through thousands of successful students.",
      color: "#141414",
      img: Report
    },
    {
      title: "Comprehensive Coverage",
      text: "Master every single PTE task with detailed video tutorials that leave nothing to chance. From basic understanding to advanced optimization techniques.",
      color: "#141414",
      img: CheckList
    },
    {
      title: "Exclusive Access",
      text: "Available only with our Gold package, ensuring you receive the highest caliber instruction reserved for our most committed students.",
      color: "#141414",
      img: Filter
    },
  ];

  const styleCard2 = [
    {
      title: "Instant Access",
      text: "Start learning immediately after upgrading to Gold",
      color: "transparent",
      img: Reward
    },
    {
      title: "Complete System",
      text: "Everything you need for PTE mastery in one package",
      color: "transparent",
      img: CheckList
    },
    {
      title: "Expert Guidance",
      text: "Learn from the only 14-time perfect scorer",
      color: "transparent",
      img: Filter
    },
    {
      title: "Proven Results",
      text: "Join 50,000+ successful students",
      color: "transparent",
      img: Reward
    },
  ];
  const goldWhyCards = [
    {
      title: "Exclusive Content",
      text: "Access training materials available nowhere else, created by the only trainer to achieve perfect scores 14 times.",
      color: "#0286FF",
      img: "/images/web-new-images/emojis/Updated/WhiteGlobe.svg"
    },
    {
      title: "Precision Training",
      text: "Learn with surgical precision rather than generic advice. Every technique is calibrated for maximum score impact.",
      color: "#0286FF",
      img: "/images/web-new-images/emojis/Updated/WhiteGlobe.svg"
    },
    {
      title: "Proven Methodology",
      text: "Follow the exact system that has guided 50,000+ students to success, refined through years of teaching excellence.",
      color: "#0286FF",
      img: "/images/web-new-images/emojis/Updated/WhiteGlobe.svg"
    },
    {
      title: "Premium Support",
      text: "Gold package subscribers receive priority access to updates, new content, and advanced training materials.",
      color: "#0286FF",
      img: "/images/web-new-images/emojis/Updated/WhiteGlobe.svg"
    },
    {
      title: "Results Guarantee",
      text: "Join the 94% of Gold package students who achieve their target scores within their subscription period.",
      color: "#0286FF",
      img: "/images/web-new-images/emojis/Updated/WhiteGlobe.svg"
    },
  ];
 const faqQuestions = [
    {
      question: "How is this video course different from other PTE training?",
      answer: "This course is created by Varun Dhawan, who has achieved a perfect 90 score in PTE Academic 14 times - something no other trainer can claim. You're learning from proven mastery, not just passing scores."
    },
    {
      question: "Can I access the video course without the Gold package?",
      answer: "No, the video course is exclusively available to Gold package subscribers. This ensures you receive the complete preparation ecosystem designed for maximum success."
    },
    {
      question: "How long do I have access to the video course?",
      answer: "Access lasts for the duration of your Gold package subscription. You can choose 1, 2, or 3-month options based on your preparation timeline."
    },
    {
      question: "Is the content updated regularly?",
      answer: "Yes, Varun continuously updates the video course content based on the latest exam patterns and feedback from recent test-takers."
    },
    {
      question: "What if I'm not satisfied with the course?",
      answer: "While we don't offer refunds, our track record speaks for itself - 94% of Gold package students achieve their target scores. We're confident you'll see the value immediately."
    },
    {
      question: "How much time should I dedicate to the video course?",
      answer: "Most students spend 2-3 hours per week with the video course, supplemented by practice using other Gold package features. The course is designed for efficient learning."
    },
  ];
  const skillAreaTitle2 = () => {
    return (
      <p className="top-section-text mb-4 FS40FW600">
        <span className="text-success ">Why Varun Dhawan's Video </span><br />
        Courses Is the Game-Changer You Need
      </p>
    )
  }
  const subTitleSection = () => {
    return (<p className="sub-title text-center FS16FW500">
      Learn from the expert who scored perfect 90 in PTE Academic 14 times and has guided 50,000+ students to success
    </p>)
  }

  const bannerTitle = () => {
    return (
      <h1 className="top-section-text mb-4 FS56FW500">
        PTE Video Course: Learn from a <span className="text-success">14-Time Perfect Scorer</span>
      </h1>
    )
  }

  const scrollToSection = () => {
    const section = sectionRef.current;
    if (section) {
      const headerHeight = document.querySelector("header").offsetHeight || 0;
      const sectionTop = section.getBoundingClientRect().top + window.scrollY;
      window.scrollTo({
        top: sectionTop - headerHeight,
        behavior: "smooth",
      });
    }
  };

  const getPackages = () => {
    const country = getCountryForTimezone(
      Intl.DateTimeFormat().resolvedOptions().timeZone
    );
    let countryId = "AU";
    if (country && country.id) {
      countryId = country.id;
    }
    const url =
      import.meta.env.VITE_URL_ALT +
      "/api/v2/getPackagesAll?countryId=" +
      countryId;
    API({
      url: url,
      method: "GET",
    }).then((res) => {
      if (res.status === 200) {
        const data = res.data;
        const laPlans = data.la.filter((plan) => plan.is_video !== 0);
        const corePlans = data.core.filter((plan) => plan.is_video !== 0);
        setPlans(laPlans);
        setCorePlans(corePlans);
        setCountry(res.data.country);
        const bestSeller = laPlans.find((p) => p.duration === 2);
        if (bestSeller) setSelectedPlanId(bestSeller.id);
      } else {
        store.dispatch(
          setAlert({ flag: true, type: 2, message: "Something went wrong." })
        );
      }
    });
  };

  useEffect(() => {
    ReactGA.initialize("UA-157984080-1");
    ReactGA.pageview(window.location.pathname + window.location.search);
    
    // ReactPixel.init("197333187452630");
    // ReactPixel.pageView();
    if (window.location.href.indexOf("#packages") != -1) {
      window.location.hash = "";
      window.location.hash = "packages";
    }
    getPackages();
  }, []);

  const CardsSlider = {
    dots: true,
    arrows: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    adaptiveHeight: true,
    autoplaySpeed: 5000,
  };
  const sliderList = {
    title: "What Our <span>Students Say</span>",
    subtitle: "Real success stories from our learners",

    settings: {
      slidesToShow: 2.5,
      autoplay: true,
    },

    items: [
      {
        id: 1,
        name: "Priya Sharma",
        location: "Mumbai, India",
        description:
          "I failed PTE twice before joining. After six weeks of coaching here I scored 79 overall. The mock tests mirror the real exam so closely — nothing caught me off guard on test day.",
        image:
          "/images/web-new-images/new-content-slider/SahidaKhatun-demo.svg",
      },
      {
        id: 2,
        name: "Rohit Nair",
        location: "Kerala, India",
        description:
          "The instant AI feedback on speaking and writing means you're not waiting days for results. That rapid loop is what made my prep feel genuinely efficient.",
        image:
          "/images/web-new-images/new-content-slider/DilmeetKingra-demo.svg",
      },
      {
        id: 3,
        name: "Li Wei",
        location: "Shanghai, China",
        description:
          "Describe Image and Retell Lecture were my worst tasks. The frameworks I learned here aren't shortcuts — they're genuinely logical structures. Scored 80 in speaking.",
        image: "/images/web-new-images/new-content-slider/SapnaPandey-demo.svg",
      },
      {
        id: 4,
        name: "Bui Thi Lan",
        location: "Ho Chi Minh City, Vietnam",
        description:
          "The online classes are genuinely as good as in-person. Teachers respond on the app outside class hours too — that kind of accessibility made a real difference during crunch weeks.",
        image: "/images/web-new-images/new-content-slider/JayPatel-demo.svg",
      },
      {
        id: 5,
        name: "Sandra Obi",
        location: "Lagos , Nigeria",
        description:
          "I needed PTE Core for my Canadian immigration application. The coaches focused on the actual CLB benchmarks, not just general English. Passed with CLB 10 in speaking and listening.",
        image: "/images/web-new-images/new-content-slider/RamimRahman-demo.svg",
      },
      {
        id: 6,
        name: "Rajan Pillai",
        location: "Trivandrum, India",
        description:
          "Switched from IELTS to PTE Core halfway through my prep. The transition guidance here was excellent — they highlighted exactly what's different without making me relearn everything.",
        image:
          "/images/web-new-images/new-content-slider/HamzaAghariya-demo.svg",
      },
    ],
  };

  const testData = {
    title: "Master Every Aspect Of The",
    highlight: "PTE Exam",
    // subtitle: "Test Sections",
    // description: 'Our specialized PTE Core Course helps you excel in every component of the PTE Core exam:',
    tabs: [
      {
        label: "Speaking Mastery",
        icon: <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M16.6673 10V10.8333C16.6673 14.5152 13.6825 17.5 10.0007 17.5C6.31875 17.5 3.33398 14.5152 3.33398 10.8333V10M10.0007 14.1667C8.1597 14.1667 6.66732 12.6743 6.66732 10.8333V5.83333C6.66732 3.99238 8.1597 2.5 10.0007 2.5C11.8416 2.5 13.334 3.99238 13.334 5.83333V10.8333C13.334 12.6743 11.8416 14.1667 10.0007 14.1667Z" stroke="white" stroke-width="2.25" stroke-linecap="round" stroke-linejoin="round" />
        </svg>,
        content: {
          leftTitle: "What You'll Learn",
          leftPoints: [
            "Pronunciation perfection, fluency optimization, and content delivery that maximizes scoring",
          ],
          rightTitle: "Varun's Approach",
          rightPoints: [
            "AI-tested pronunciation techniques, confidence-building exercises, and the psychological preparation that eliminates speaking anxiety",
          ],
        },
      },
      {
        label: "Listening Excellence",
        icon: <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M17.5 15V10C17.5 5.85786 14.1421 2.5 10 2.5C5.85786 2.5 2.5 5.85786 2.5 10V15M4.58333 17.5C3.43274 17.5 2.5 16.5673 2.5 15.4167V13.75C2.5 12.5994 3.43274 11.6667 4.58333 11.6667C5.73393 11.6667 6.66667 12.5994 6.66667 13.75V15.4167C6.66667 16.5673 5.73393 17.5 4.58333 17.5ZM15.4167 17.5C14.2661 17.5 13.3333 16.5673 13.3333 15.4167V13.75C13.3333 12.5994 14.2661 11.6667 15.4167 11.6667C16.5673 11.6667 17.5 12.5994 17.5 13.75V15.4167C17.5 16.5673 16.5673 17.5 15.4167 17.5Z" stroke="white" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" />
        </svg>,
        content: {
          leftTitle: "What You'll Learn",
          leftPoints: ["Advanced comprehension strategies, note-taking systems, and accent adaptation techniques"],
          rightTitle: "Varun's Approach",
          rightPoints: ["Active listening protocols, key information identification, and the concentration methods used by top scorers"],
        },
      },
       {
        label: "Reading Domination",
        icon: <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M10.0013 17.5L9.91792 17.3749C9.33905 16.5066 9.04962 16.0725 8.66722 15.7582C8.32868 15.4799 7.93861 15.2712 7.51931 15.1438C7.04568 15 6.52389 15 5.48032 15H4.33464C3.40121 15 2.9345 15 2.57798 14.8183C2.26438 14.6586 2.00941 14.4036 1.84962 14.09C1.66797 13.7335 1.66797 13.2668 1.66797 12.3333V5.16667C1.66797 4.23325 1.66797 3.76654 1.84962 3.41002C2.00941 3.09641 2.26438 2.84144 2.57798 2.68166C2.9345 2.5 3.40121 2.5 4.33464 2.5H4.66797C6.53481 2.5 7.46823 2.5 8.18127 2.86331C8.80848 3.18289 9.31841 3.69282 9.63799 4.32003C10.0013 5.03307 10.0013 5.96649 10.0013 7.83333M10.0013 17.5V7.83333M10.0013 17.5L10.0847 17.3749C10.6635 16.5066 10.953 16.0725 11.3354 15.7582C11.6739 15.4799 12.064 15.2712 12.4833 15.1438C12.9569 15 13.4787 15 14.5223 15H15.668C16.6014 15 17.0681 15 17.4246 14.8183C17.7382 14.6586 17.9932 14.4036 18.153 14.09C18.3346 13.7335 18.3346 13.2668 18.3346 12.3333V5.16667C18.3346 4.23325 18.3346 3.76654 18.153 3.41002C17.9932 3.09641 17.7382 2.84144 17.4246 2.68166C17.0681 2.5 16.6014 2.5 15.668 2.5H15.3346C13.4678 2.5 12.5344 2.5 11.8213 2.86331C11.1941 3.18289 10.6842 3.69282 10.3646 4.32003C10.0013 5.03307 10.0013 5.96649 10.0013 7.83333" stroke="white" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" />
        </svg>
        ,
        content: {
          leftTitle: "What You'll Learn",
          leftPoints: ["Speed reading with comprehension, passage analysis, and time management mastery"],
          rightTitle: "Varun's Approach",
          rightPoints: ["Strategic reading patterns, vocabulary optimization, and the systematic approach to complex texts"],
        },
      },
      {
        label: "Writing Perfection",
        icon: <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
          <g clip-path="url(#clip0_2010_471)">
            <path d="M10.8346 4.99987L5.41949 6.0829C5.11699 6.1434 4.96574 6.17365 4.84257 6.24721C4.73368 6.31224 4.64107 6.40127 4.5718 6.50751C4.49344 6.62768 4.45725 6.77762 4.38487 7.07749L1.66797 18.3332M1.66797 18.3332L12.9237 15.6163C13.2236 15.5439 13.3735 15.5077 13.4937 15.4294C13.5999 15.3601 13.6889 15.2675 13.754 15.1586C13.8275 15.0354 13.8578 14.8842 13.9183 14.5817L15.0013 9.16654M1.66797 18.3332L7.98964 12.0115M17.3918 6.55707L13.4441 2.60935C13.1141 2.27934 12.9491 2.11433 12.7588 2.0525C12.5914 1.99812 12.4112 1.99812 12.2438 2.05251C12.0535 2.11433 11.8885 2.27934 11.5585 2.60935L10.9441 3.22373C10.6141 3.55375 10.4491 3.71875 10.3873 3.90903C10.3329 4.0764 10.3329 4.25669 10.3873 4.42406C10.4491 4.61433 10.6141 4.77934 10.9441 5.10935L14.8918 9.05707C15.2218 9.38708 15.3868 9.55209 15.5771 9.61391C15.7445 9.66829 15.9248 9.66829 16.0922 9.61391C16.2824 9.55209 16.4474 9.38708 16.7774 9.05706L17.3918 8.44268C17.7218 8.11267 17.8868 7.94766 17.9487 7.75739C18.0031 7.59002 18.0031 7.40973 17.9487 7.24236C17.8868 7.05209 17.7218 6.88708 17.3918 6.55707ZM9.16797 9.16654C10.0884 9.16654 10.8346 9.91273 10.8346 10.8332C10.8346 11.7537 10.0884 12.4999 9.16797 12.4999C8.24749 12.4999 7.5013 11.7537 7.5013 10.8332C7.5013 9.91273 8.24749 9.16654 9.16797 9.16654Z" stroke="white" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" />
          </g>
        </svg>,
        content: {
          leftTitle: "What You'll Learn",
          leftPoints: ["Essay structuring, grammar excellence, and response optimization for maximum scoring"],
          rightTitle: "Varun's Approach",
          rightPoints: ["Template mastery, idea development systems, and the writing methodology that guarantees high scores"],
        },
      },
     
      
    ],
    cta: "Experience Complete PTE Mastery",
  };

  return (
    <React.Fragment>
      <Helmet>
        <title>Get Exclusive PTE Video Course | LA Language Academy</title>
        <meta name="description" content="Unlock your PTE potential with Varun Dhawan's exclusive gold package video course. Learn from Australia's only 14-time perfect scorer. Get comprehensive tutorials." />
        <meta name="robots" content="index, follow" />
        <link rel="canonical" href={`https://www.languageacademy.com.au/video-courses`} />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:site" content="@languageacademy" />
        <meta name="twitter:title" content="Get Exclusive PTE Video Course | LA Language Academy" />
        <meta name="twitter:description" content="Unlock your PTE potential with Varun Dhawan's exclusive gold package video course. Learn from Australia's only 14-time perfect scorer. Get comprehensive tutorials." />
        <meta name="twitter:image" content={`https://www.languageacademy.com.au/images/logol.png`} />
        <meta name="twitter:image:alt" content="LA Language Academy Logo" />
        <meta property="og:url" content={`https://www.languageacademy.com.au/video-courses`} />
        <meta property="og:type" content="website" />
        <meta property="og:title" content="Get Exclusive PTE Video Course | LA Language Academy" />
        <meta property="og:description" content="Unlock your PTE potential with Varun Dhawan's exclusive gold package video course. Learn from Australia's only 14-time perfect scorer. Get comprehensive tutorials." />
        <meta property="og:image" content={`https://www.languageacademy.com.au/images/logol.png`} />
        <meta property="og:image:alt" content="LA Language Academy Logo" />
        <meta property="og:image:width" content="1200" />
        <meta property="og:image:height" content="630" />
      </Helmet>
      <div className="new-design">
        <Header />
        <div className="innerPage">

          <BannerHeader title={bannerTitle} blueBoxText={blueBoxText} subTitle={subTitleSection} backgroundColor='#fff' textColor="black" middleSection={() => {
            return (
              <div id="banner-hero-section" style={{ marginTop: "50px" }}>
                <div className="vc-hero-row">
                  {/* Left Student */}
                  <div className="vc-hero-student vc-hero-student--left">
                    <img src={LeftStudent} alt="Student" style={{ height: '200p' }} />
                  </div>

                  {/* Center Video */}
                  <div className="vc-hero-video">
                    <video
                      controls
                      poster={VideoCourseImage}
                    >
                      <source src={CourseVideo} type="video/mp4" />
                      Your browser does not support the video tag.
                    </video>
                  </div>

                  {/* Right Student */}
                  <div className="vc-hero-student vc-hero-student--right">
                    <img src={RightStudent} alt="Student" />
                  </div>
                </div>
              </div>
            )
          }} />

          {/* PTE Preparation CTA Banner */}
          <div className="vc-pte-cta-banner">
            {/* Background glow */}
            <div className="vc-pte-cta-glow"></div>

            {/* Left decorative icon */}
            <div className="vc-pte-cta-icon vc-pte-cta-icon--left">
              <svg width="250" height="250" viewBox="0 0 250 250" fill="none" xmlns="http://www.w3.org/2000/svg">
                <rect x="10" y="23" width="230" height="163" rx="16" fill="rgba(255,255,255,0.04)" />
                <rect x="68" y="45" width="115" height="90" rx="8" fill="rgba(255,255,255,0.04)" />
                <polygon points="100,65 100,120 140,92" fill="rgba(255,255,255,0.04)" />
                <rect x="14" y="200" width="226" height="27" rx="8" fill="rgba(255,255,255,0.04)" />
              </svg>
            </div>

            {/* Right decorative icon */}
            <div className="vc-pte-cta-icon vc-pte-cta-icon--right">
              <svg width="250" height="250" viewBox="0 0 250 250" fill="none" xmlns="http://www.w3.org/2000/svg">
                <rect x="10" y="23" width="230" height="163" rx="16" fill="rgba(255,255,255,0.04)" />
                <rect x="68" y="45" width="115" height="90" rx="8" fill="rgba(255,255,255,0.04)" />
                <polygon points="100,65 100,120 140,92" fill="rgba(255,255,255,0.04)" />
                <rect x="14" y="200" width="226" height="27" rx="8" fill="rgba(255,255,255,0.04)" />
              </svg>
            </div>

            {/* Content */}
            <div className="vc-pte-cta-content">
              <h2 className="vc-pte-cta-title FS40FW600">Your Complete PTE Preparation Starts Here</h2>
              <p className="vc-pte-cta-subtitle FS20FW500">
                Learn proven strategies, practice real exam questions, and boost your PTE
                score with our structured video lessons.
              </p>
            </div>

            {/* CTA Button */}
            <button className="vc-pte-cta-btn" onClick={scrollToSection}>
              <span>Get the Video Course</span>
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M7 17L17 7M17 7H7M17 7V17" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
              </svg>
            </button>
          </div>

          <div className="fame-wall" style={{ paddingTop: "unset" }}>
            <ReusableHomePageSlider images={images} />
          </div>
          
          <div className="d-flex align-items-center gap-3 flex-column pb-4">
            <p className="sub-title text-align-center">
             {"                       "} Unlock your PTE potential with our comprehensive video course, featuring proven strategies, expert insights, and step-by- <br />step guidance from Australia's most successful PTE trainer.
              Available exclusively with our Gold package - the complete preparation system that transforms your PTE performance.

            </p><ButtonComp btnText="Register For Preparation Now" link="/auth/register" />
          </div>
          <AiPower />

          {/* What Is The Language Academy PTE Video Course */}
          <div className="vc-what-section">
            {/* Top row: Title + CTA */}
            <div className="vc-what-top">
              <div className="vc-what-top__left">
                <h2 className="vc-what-top__title FS40FW600">
                  What Is The Language Academy<br />
                  <span className="green-text">PTE Video Course?</span>
                </h2>
              </div>
              <div className="vc-what-top__right">
                <p className="vc-what-top__desc quote-para FS18FW400">
                  The most comprehensive PTE training available anywhere, created by Australia's #1 PTE expert.
                </p>
                <ButtonComp btnText="Start Your Transformation" link="/auth/register" />
              </div>
            </div>

            {/* Bottom row: Image + Features */}
            <div className="vc-what-bottom">
              {/* Left: Image + Tagline */}
              <div className="vc-what-bottom__left">
                <div className="vc-what-bottom__image">
                  <img src={ListeningStudent} alt="PTE Video Course" />
                </div>
                <div className="vc-what-bottom__tagline">
                  <p>
                    Our exclusive PTE Video Course represents over 6 years of teaching excellence and real-world exam mastery, condensed into the ultimate learning experience.
                  </p>
                </div>
              </div>

              {/* Right: Features card */}
              <div className="vc-what-bottom__right">
                <p className="vc-what-bottom__intro quote-para FS16FW500">
                  Developed personally by Varun Dhawan – the only trainer to achieve a perfect 90 score in PTE Academic 14 times – this course reveals the exact strategies, techniques, and insider knowledge that have helped over 50,000 students achieve their target scores.
                </p>
                <hr className="vc-what-bottom__divider" />
                <h3 className="vc-what-bottom__subtitle FS24FW500 F-600">Why This Course Changes Everything:</h3>
                <div className="vc-what-bottom__features">
                  <div className="vc-what-bottom__feature">
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M20 6L9 17L4 12" stroke="#94C23C" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                    </svg>
                    <p><strong>Expert Proven:</strong> Created by someone who has mastered the exam at the highest level</p>
                  </div>
                  <div className="vc-what-bottom__feature">
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M20 6L9 17L4 12" stroke="#94C23C" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                    </svg>
                    <p><strong>Results Driven:</strong> Strategies tested and refined through 50,000+ student successes</p>
                  </div>
                  <div className="vc-what-bottom__feature">
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M20 6L9 17L4 12" stroke="#94C23C" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                    </svg>
                    <p><strong>Comprehensive:</strong> Every PTE task covered in exhaustive detail</p>
                  </div>
                  <div className="vc-what-bottom__feature">
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M20 6L9 17L4 12" stroke="#94C23C" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                    </svg>
                    <p><strong>Exclusive:</strong> Only available to Gold package subscribers</p>
                  </div>
                </div>
                <p className="vc-what-bottom__footer quote-para FS16FW500">
                  This isn't just another video course – it's your direct access to the mind of PTE's most successful trainer.
                </p>
              </div>
            </div>
          </div>


          <SkillAreas
            className={"skill-section"}
            background={"white"}
            color={"black"}
            skillAreaTitle={skillAreaTitle2}
            lifestyleCards={styleCards}
            btnText={"Start Your Preparation Now"}
            skillSubtitle={"<strong>When you learn from the best, there's no room for error.</strong><br/> Most PTE courses are taught by instructors who have simply passed the exam. Varun<br/> Dhawan has conquered it - achieving the maximum possible score not once, but 14 times."}
            TopMiddleSection={() => {
            return (
              <p className="sub-title text-center FS16FW500 my-5" style={{color:'#383838'}}>
                This course doesn't just teach PTE strategies - it reveals the mindset, approach, and precise techniques<br/> of someone who has mastered every aspect of the exam.
              </p>
            )
          }}
          />
          {/* PTE App Download Section */}
          {/* <PteAppBanner /> */}
          <AppBannerCustom
            appName="PTE"
            description="PTE PRACTICE"
            mobileImage="/images/web-new-images/HomePageImage/PTE-app-1.png"
            playStoreLink={`${import.meta.env.VITE_PTE_ANDROID_APP_URL}`}
            appStoreLink={`${import.meta.env.VITE_PTE_IOS_APP_URL}`}
          />

          <div className="master-all-pte d-none">
            <div className="container">
              <div className="row">
                <div className="master-all-header">
                  <h2 className="primary-heading fw-700 text-center text-white">
                    EXCEL IN EVERY <br />
                    <span className="wpl-badge pte-naati-badge text-white">
                      PTE SKILL AREA
                    </span>{" "}
                    WITH <br /> OUR STRATEGIES
                  </h2>
                </div>
              </div>
              <div className="master-all-tabs">
                <ul className="nav nav-tabs" id="myTab" role="tablist">
                  <li className="nav-item" role="presentation">
                    <button
                      className="nav-link active"
                      id="speak-tab"
                      data-bs-toggle="tab"
                      data-bs-target="#speak-tab-pane"
                      type="button"
                      role="tab"
                      aria-controls="speak-tab-pane"
                      aria-selected="true"
                    >
                      <img
                        src="/images/web-new-images/icons/w-speak-icon.svg"
                        alt="Register Now"
                      />{" "}
                      Speaking
                    </button>
                  </li>
                  <li className="nav-item" role="presentation">
                    <button
                      className="nav-link"
                      id="write-tab"
                      data-bs-toggle="tab"
                      data-bs-target="#write-tab-pane"
                      type="button"
                      role="tab"
                      aria-controls="write-tab-pane"
                      aria-selected="false"
                    >
                      <img
                        src="/images/web-new-images/icons/w-write-icon.svg"
                        alt="Register Now"
                      />{" "}
                      Writing
                    </button>
                  </li>
                  <li className="nav-item" role="presentation">
                    <button
                      className="nav-link"
                      id="profile-tab"
                      data-bs-toggle="tab"
                      data-bs-target="#profile-tab-pane"
                      type="button"
                      role="tab"
                      aria-controls="profile-tab-pane"
                      aria-selected="false"
                    >
                      <img
                        src="/images/web-new-images/icons/w-reading-icon.svg"
                        alt="Register Now"
                      />{" "}
                      Reading
                    </button>
                  </li>
                  <li className="nav-item" role="presentation">
                    <button
                      className="nav-link"
                      id="home-tab"
                      data-bs-toggle="tab"
                      data-bs-target="#home-tab-pane"
                      type="button"
                      role="tab"
                      aria-controls="home-tab-pane"
                      aria-selected="false"
                    >
                      <img
                        src="/images/web-new-images/icons/w-listen-icon.svg"
                        alt="Register Now"
                      />{" "}
                      Listening
                    </button>
                  </li>
                </ul>
                <div className="tab-content" id="myTabContent">
                  <div
                    className="tab-pane fade"
                    id="home-tab-pane"
                    role="tabpanel"
                    aria-labelledby="home-tab"
                    tabIndex="0"
                  >
                    <div className="lets-coaching-tab-cards">
                      <div className="lets-coaching-tab-left-card">
                        <div className="card-img">
                          <svg width="54" height="52" viewBox="0 0 54 52" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <rect width="54" height="52" rx="16" fill="#0286FF" />
                            <g clip-path="url(#clip0_17515_8851)">
                              <path d="M39.7308 13.5798C36.3328 10.1819 31.8116 8.31055 27 8.31055C22.1884 8.31055 17.6672 10.1819 14.2692 13.5798C10.8713 16.9776 9 21.4989 9 26.3105C9 31.1222 10.8713 35.6434 14.2692 39.0413C17.6671 42.4393 22.1884 44.3105 27 44.3105C31.8116 44.3105 36.3328 42.4392 39.7308 39.0413C43.1287 35.6435 45 31.1222 45 26.3105C45 21.4989 43.1287 16.9777 39.7308 13.5798ZM27 42.0837C18.3026 42.0837 11.2268 35.0079 11.2268 26.3105C11.2268 17.6132 18.3026 10.5374 27 10.5374C35.6974 10.5374 42.7732 17.6132 42.7732 26.3105C42.7732 35.0079 35.6974 42.0837 27 42.0837Z" fill="white" />
                              <path d="M35.7497 17.561C33.4143 15.2257 30.3069 13.9395 27.0001 13.9395C23.6932 13.9395 20.5858 15.2256 18.2504 17.561C15.915 19.8964 14.6289 23.0037 14.6289 26.3106C14.6289 29.6175 15.915 32.7248 18.2504 35.0602C20.5858 37.3956 23.6932 38.6818 27.0001 38.6818C30.3069 38.6818 33.4143 37.3956 35.7497 35.0602C38.0851 32.7248 39.3712 29.6175 39.3712 26.3106C39.3712 23.0037 38.0851 19.8964 35.7497 17.561ZM27.0001 36.455C21.4065 36.455 16.8557 31.9042 16.8557 26.3106C16.8557 20.717 21.4065 16.1663 27.0001 16.1663C32.5936 16.1663 37.1444 20.717 37.1444 26.3106C37.1444 31.9042 32.5936 36.455 27.0001 36.455Z" fill="white" />
                              <path d="M27.0001 19.5684C23.2823 19.5684 20.2578 22.593 20.2578 26.3106C20.2578 30.0283 23.2823 33.0528 27.0001 33.0528C30.7178 33.0528 33.7423 30.0283 33.7423 26.3106C33.7423 22.593 30.7178 19.5684 27.0001 19.5684ZM27.0001 30.826C24.5103 30.826 22.4846 28.8004 22.4846 26.3106C22.4846 23.8208 24.5103 21.7952 27.0001 21.7952C29.4898 21.7952 31.5155 23.8208 31.5155 26.3106C31.5155 28.8004 29.4898 30.826 27.0001 30.826Z" fill="white" />
                            </g>
                            <defs>
                              <clipPath id="clip0_17515_8851">
                                <rect width="36" height="36" fill="white" transform="translate(9 8.31055)" />
                              </clipPath>
                            </defs>
                          </svg>


                        </div>
                        <h2 className="m-0">What It Tests</h2>
                        <ul className="p-0">
                          <li>
                            Ability to comprehend spoken English, understand main ideas, and follow instructions.
                          </li>
                        </ul>
                      </div>
                      <div className="lets-coaching-tab-right-card">
                        <div className="card-img">
                          <svg width="54" height="52" viewBox="0 0 54 52" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <rect width="54" height="52" rx="16" fill="#0286FF" />
                            <g clip-path="url(#clip0_17515_8861)">
                              <path d="M24.7284 17.0819C21.3516 17.8692 18.6332 20.5472 17.8031 23.9044C16.9704 27.2723 17.9234 30.7051 20.3526 33.0873C21.2118 33.93 21.7248 35.2806 21.7248 36.7003V36.9269C21.7248 37.8618 22.1327 38.703 22.7795 39.2827V41.1456C22.7795 42.8903 24.1989 44.3097 25.9436 44.3097H28.053C29.7976 44.3097 31.217 42.8903 31.217 41.1456V39.2827C31.8638 38.703 32.2717 37.8618 32.2717 36.9269V36.6961C32.2717 35.298 32.8122 33.9217 33.7176 33.0145C35.5057 31.2224 36.4905 28.8413 36.4905 26.3097C36.4905 20.2573 30.8817 15.6476 24.7284 17.0819ZM29.1077 41.1456C29.1077 41.7272 28.6345 42.2003 28.053 42.2003H25.9436C25.362 42.2003 24.8889 41.7272 24.8889 41.1456V40.0909H29.1077V41.1456ZM32.2243 31.5245C30.9139 32.8377 30.1623 34.7227 30.1623 36.6961V36.9269C30.1623 37.5084 29.6892 37.9816 29.1077 37.9816H24.8889C24.3073 37.9816 23.8342 37.5084 23.8342 36.9269V36.7003C23.8342 34.6964 23.1035 32.8306 21.8294 31.5812C19.9387 29.7271 19.1991 27.0466 19.8507 24.4107C20.4923 21.8157 22.595 19.7452 25.2074 19.1362C30.0359 18.0103 34.3811 21.6148 34.3811 26.3097C34.3811 28.2787 33.6151 30.1307 32.2243 31.5245Z" fill="white" />
                              <path d="M18.7953 16.6162L15.8122 13.6331C15.4004 13.2212 14.7325 13.2212 14.3206 13.6331C13.9087 14.045 13.9087 14.7128 14.3206 15.1247L17.3038 18.1078C17.7156 18.5196 18.3835 18.5196 18.7953 18.1078C19.2072 17.6959 19.2072 17.0281 18.7953 16.6162Z" fill="white" />
                              <path d="M14.3438 25.2559H10.0547C9.47222 25.2559 9 25.7281 9 26.3105C9 26.893 9.47222 27.3652 10.0547 27.3652H14.3438C14.9262 27.3652 15.3984 26.893 15.3984 26.3105C15.3984 25.7281 14.9262 25.2559 14.3438 25.2559Z" fill="white" />
                              <path d="M43.9453 25.2559H39.6562C39.0738 25.2559 38.6016 25.7281 38.6016 26.3105C38.6016 26.893 39.0738 27.3652 39.6562 27.3652H43.9453C44.5278 27.3652 45 26.893 45 26.3105C45 25.7281 44.5278 25.2559 43.9453 25.2559Z" fill="white" />
                              <path d="M39.6781 13.6331C39.2664 13.2212 38.5986 13.2212 38.1866 13.6331L35.2034 16.6162C34.7916 17.028 34.7916 17.6959 35.2034 18.1078C35.6153 18.5196 36.2831 18.5196 36.695 18.1078L39.6781 15.1247C40.09 14.7129 40.09 14.045 39.6781 13.6331Z" fill="white" />
                              <path d="M27 8.31055C26.4175 8.31055 25.9453 8.78277 25.9453 9.36523V13.6543C25.9453 14.2368 26.4175 14.709 27 14.709C27.5825 14.709 28.0547 14.2368 28.0547 13.6543V9.36523C28.0547 8.78277 27.5825 8.31055 27 8.31055Z" fill="white" />
                              <path d="M26.9987 21.0371C26.5652 21.0371 26.1235 21.0891 25.6868 21.1914C23.8682 21.6159 22.3457 23.1129 21.8984 24.9165C21.7582 25.4818 22.1028 26.0538 22.6682 26.194C23.2336 26.3342 23.8055 25.9895 23.9457 25.4243C24.2032 24.3866 25.1162 23.4907 26.1671 23.2453C26.4471 23.1797 26.7269 23.1465 26.9987 23.1465C27.5812 23.1465 28.0534 22.6743 28.0534 22.0918C28.0534 21.5093 27.5812 21.0371 26.9987 21.0371Z" fill="white" />
                            </g>
                            <defs>
                              <clipPath id="clip0_17515_8861">
                                <rect width="36" height="36" fill="white" transform="translate(9 8.31055)" />
                              </clipPath>
                            </defs>
                          </svg>
                        </div>
                        <h2 className="m-0">Our Approach</h2>
                        <ul className="p-0">
                          <li>
                            Practice identifying key details, understanding accents, and strengthening active listening skills.
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                  <div
                    className="tab-pane fade"
                    id="profile-tab-pane"
                    role="tabpanel"
                    aria-labelledby="profile-tab"
                    tabIndex="0"
                  >
                    <div className="lets-coaching-tab-cards">
                      <div className="lets-coaching-tab-left-card">
                        <div className="card-img">
                          <svg width="54" height="52" viewBox="0 0 54 52" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <rect width="54" height="52" rx="16" fill="#0286FF" />
                            <g clip-path="url(#clip0_17515_8851)">
                              <path d="M39.7308 13.5798C36.3328 10.1819 31.8116 8.31055 27 8.31055C22.1884 8.31055 17.6672 10.1819 14.2692 13.5798C10.8713 16.9776 9 21.4989 9 26.3105C9 31.1222 10.8713 35.6434 14.2692 39.0413C17.6671 42.4393 22.1884 44.3105 27 44.3105C31.8116 44.3105 36.3328 42.4392 39.7308 39.0413C43.1287 35.6435 45 31.1222 45 26.3105C45 21.4989 43.1287 16.9777 39.7308 13.5798ZM27 42.0837C18.3026 42.0837 11.2268 35.0079 11.2268 26.3105C11.2268 17.6132 18.3026 10.5374 27 10.5374C35.6974 10.5374 42.7732 17.6132 42.7732 26.3105C42.7732 35.0079 35.6974 42.0837 27 42.0837Z" fill="white" />
                              <path d="M35.7497 17.561C33.4143 15.2257 30.3069 13.9395 27.0001 13.9395C23.6932 13.9395 20.5858 15.2256 18.2504 17.561C15.915 19.8964 14.6289 23.0037 14.6289 26.3106C14.6289 29.6175 15.915 32.7248 18.2504 35.0602C20.5858 37.3956 23.6932 38.6818 27.0001 38.6818C30.3069 38.6818 33.4143 37.3956 35.7497 35.0602C38.0851 32.7248 39.3712 29.6175 39.3712 26.3106C39.3712 23.0037 38.0851 19.8964 35.7497 17.561ZM27.0001 36.455C21.4065 36.455 16.8557 31.9042 16.8557 26.3106C16.8557 20.717 21.4065 16.1663 27.0001 16.1663C32.5936 16.1663 37.1444 20.717 37.1444 26.3106C37.1444 31.9042 32.5936 36.455 27.0001 36.455Z" fill="white" />
                              <path d="M27.0001 19.5684C23.2823 19.5684 20.2578 22.593 20.2578 26.3106C20.2578 30.0283 23.2823 33.0528 27.0001 33.0528C30.7178 33.0528 33.7423 30.0283 33.7423 26.3106C33.7423 22.593 30.7178 19.5684 27.0001 19.5684ZM27.0001 30.826C24.5103 30.826 22.4846 28.8004 22.4846 26.3106C22.4846 23.8208 24.5103 21.7952 27.0001 21.7952C29.4898 21.7952 31.5155 23.8208 31.5155 26.3106C31.5155 28.8004 29.4898 30.826 27.0001 30.826Z" fill="white" />
                            </g>
                            <defs>
                              <clipPath id="clip0_17515_8851">
                                <rect width="36" height="36" fill="white" transform="translate(9 8.31055)" />
                              </clipPath>
                            </defs>
                          </svg>


                        </div>
                        <h2 className="m-0">What It Tests</h2>
                        <ul className="p-0">
                          <li>
                            Vocabulary comprehension, text analysis, and structure awareness.
                          </li>
                        </ul>
                      </div>
                      <div className="lets-coaching-tab-right-card">
                        <div className="card-img">
                          <svg width="54" height="52" viewBox="0 0 54 52" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <rect width="54" height="52" rx="16" fill="#0286FF" />
                            <g clip-path="url(#clip0_17515_8861)">
                              <path d="M24.7284 17.0819C21.3516 17.8692 18.6332 20.5472 17.8031 23.9044C16.9704 27.2723 17.9234 30.7051 20.3526 33.0873C21.2118 33.93 21.7248 35.2806 21.7248 36.7003V36.9269C21.7248 37.8618 22.1327 38.703 22.7795 39.2827V41.1456C22.7795 42.8903 24.1989 44.3097 25.9436 44.3097H28.053C29.7976 44.3097 31.217 42.8903 31.217 41.1456V39.2827C31.8638 38.703 32.2717 37.8618 32.2717 36.9269V36.6961C32.2717 35.298 32.8122 33.9217 33.7176 33.0145C35.5057 31.2224 36.4905 28.8413 36.4905 26.3097C36.4905 20.2573 30.8817 15.6476 24.7284 17.0819ZM29.1077 41.1456C29.1077 41.7272 28.6345 42.2003 28.053 42.2003H25.9436C25.362 42.2003 24.8889 41.7272 24.8889 41.1456V40.0909H29.1077V41.1456ZM32.2243 31.5245C30.9139 32.8377 30.1623 34.7227 30.1623 36.6961V36.9269C30.1623 37.5084 29.6892 37.9816 29.1077 37.9816H24.8889C24.3073 37.9816 23.8342 37.5084 23.8342 36.9269V36.7003C23.8342 34.6964 23.1035 32.8306 21.8294 31.5812C19.9387 29.7271 19.1991 27.0466 19.8507 24.4107C20.4923 21.8157 22.595 19.7452 25.2074 19.1362C30.0359 18.0103 34.3811 21.6148 34.3811 26.3097C34.3811 28.2787 33.6151 30.1307 32.2243 31.5245Z" fill="white" />
                              <path d="M18.7953 16.6162L15.8122 13.6331C15.4004 13.2212 14.7325 13.2212 14.3206 13.6331C13.9087 14.045 13.9087 14.7128 14.3206 15.1247L17.3038 18.1078C17.7156 18.5196 18.3835 18.5196 18.7953 18.1078C19.2072 17.6959 19.2072 17.0281 18.7953 16.6162Z" fill="white" />
                              <path d="M14.3438 25.2559H10.0547C9.47222 25.2559 9 25.7281 9 26.3105C9 26.893 9.47222 27.3652 10.0547 27.3652H14.3438C14.9262 27.3652 15.3984 26.893 15.3984 26.3105C15.3984 25.7281 14.9262 25.2559 14.3438 25.2559Z" fill="white" />
                              <path d="M43.9453 25.2559H39.6562C39.0738 25.2559 38.6016 25.7281 38.6016 26.3105C38.6016 26.893 39.0738 27.3652 39.6562 27.3652H43.9453C44.5278 27.3652 45 26.893 45 26.3105C45 25.7281 44.5278 25.2559 43.9453 25.2559Z" fill="white" />
                              <path d="M39.6781 13.6331C39.2664 13.2212 38.5986 13.2212 38.1866 13.6331L35.2034 16.6162C34.7916 17.028 34.7916 17.6959 35.2034 18.1078C35.6153 18.5196 36.2831 18.5196 36.695 18.1078L39.6781 15.1247C40.09 14.7129 40.09 14.045 39.6781 13.6331Z" fill="white" />
                              <path d="M27 8.31055C26.4175 8.31055 25.9453 8.78277 25.9453 9.36523V13.6543C25.9453 14.2368 26.4175 14.709 27 14.709C27.5825 14.709 28.0547 14.2368 28.0547 13.6543V9.36523C28.0547 8.78277 27.5825 8.31055 27 8.31055Z" fill="white" />
                              <path d="M26.9987 21.0371C26.5652 21.0371 26.1235 21.0891 25.6868 21.1914C23.8682 21.6159 22.3457 23.1129 21.8984 24.9165C21.7582 25.4818 22.1028 26.0538 22.6682 26.194C23.2336 26.3342 23.8055 25.9895 23.9457 25.4243C24.2032 24.3866 25.1162 23.4907 26.1671 23.2453C26.4471 23.1797 26.7269 23.1465 26.9987 23.1465C27.5812 23.1465 28.0534 22.6743 28.0534 22.0918C28.0534 21.5093 27.5812 21.0371 26.9987 21.0371Z" fill="white" />
                            </g>
                            <defs>
                              <clipPath id="clip0_17515_8861">
                                <rect width="36" height="36" fill="white" transform="translate(9 8.31055)" />
                              </clipPath>
                            </defs>
                          </svg>
                        </div>
                        <h2 className="m-0">Our Approach</h2>
                        <ul className="p-0">
                          <li>
                            Time management techniques, sentence reordering, and vocabulary-building exercises.
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                  <div
                    className="tab-pane fade"
                    id="write-tab-pane"
                    role="tabpanel"
                    aria-labelledby="write-tab"
                    tabIndex="0"
                  >
                    <div className="lets-coaching-tab-cards">
                      <div className="lets-coaching-tab-left-card">
                        <div className="card-img">
                          <svg width="54" height="52" viewBox="0 0 54 52" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <rect width="54" height="52" rx="16" fill="#0286FF" />
                            <g clip-path="url(#clip0_17515_8851)">
                              <path d="M39.7308 13.5798C36.3328 10.1819 31.8116 8.31055 27 8.31055C22.1884 8.31055 17.6672 10.1819 14.2692 13.5798C10.8713 16.9776 9 21.4989 9 26.3105C9 31.1222 10.8713 35.6434 14.2692 39.0413C17.6671 42.4393 22.1884 44.3105 27 44.3105C31.8116 44.3105 36.3328 42.4392 39.7308 39.0413C43.1287 35.6435 45 31.1222 45 26.3105C45 21.4989 43.1287 16.9777 39.7308 13.5798ZM27 42.0837C18.3026 42.0837 11.2268 35.0079 11.2268 26.3105C11.2268 17.6132 18.3026 10.5374 27 10.5374C35.6974 10.5374 42.7732 17.6132 42.7732 26.3105C42.7732 35.0079 35.6974 42.0837 27 42.0837Z" fill="white" />
                              <path d="M35.7497 17.561C33.4143 15.2257 30.3069 13.9395 27.0001 13.9395C23.6932 13.9395 20.5858 15.2256 18.2504 17.561C15.915 19.8964 14.6289 23.0037 14.6289 26.3106C14.6289 29.6175 15.915 32.7248 18.2504 35.0602C20.5858 37.3956 23.6932 38.6818 27.0001 38.6818C30.3069 38.6818 33.4143 37.3956 35.7497 35.0602C38.0851 32.7248 39.3712 29.6175 39.3712 26.3106C39.3712 23.0037 38.0851 19.8964 35.7497 17.561ZM27.0001 36.455C21.4065 36.455 16.8557 31.9042 16.8557 26.3106C16.8557 20.717 21.4065 16.1663 27.0001 16.1663C32.5936 16.1663 37.1444 20.717 37.1444 26.3106C37.1444 31.9042 32.5936 36.455 27.0001 36.455Z" fill="white" />
                              <path d="M27.0001 19.5684C23.2823 19.5684 20.2578 22.593 20.2578 26.3106C20.2578 30.0283 23.2823 33.0528 27.0001 33.0528C30.7178 33.0528 33.7423 30.0283 33.7423 26.3106C33.7423 22.593 30.7178 19.5684 27.0001 19.5684ZM27.0001 30.826C24.5103 30.826 22.4846 28.8004 22.4846 26.3106C22.4846 23.8208 24.5103 21.7952 27.0001 21.7952C29.4898 21.7952 31.5155 23.8208 31.5155 26.3106C31.5155 28.8004 29.4898 30.826 27.0001 30.826Z" fill="white" />
                            </g>
                            <defs>
                              <clipPath id="clip0_17515_8851">
                                <rect width="36" height="36" fill="white" transform="translate(9 8.31055)" />
                              </clipPath>
                            </defs>
                          </svg>


                        </div>
                        <h2 className="m-0">What It Tests</h2>
                        <ul className="p-0">
                          <li>
                            Essay composition, grammar accuracy, and passage summarization.
                          </li>
                        </ul>
                      </div>
                      <div className="lets-coaching-tab-right-card">
                        <div className="card-img">
                          <svg width="54" height="52" viewBox="0 0 54 52" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <rect width="54" height="52" rx="16" fill="#0286FF" />
                            <g clip-path="url(#clip0_17515_8861)">
                              <path d="M24.7284 17.0819C21.3516 17.8692 18.6332 20.5472 17.8031 23.9044C16.9704 27.2723 17.9234 30.7051 20.3526 33.0873C21.2118 33.93 21.7248 35.2806 21.7248 36.7003V36.9269C21.7248 37.8618 22.1327 38.703 22.7795 39.2827V41.1456C22.7795 42.8903 24.1989 44.3097 25.9436 44.3097H28.053C29.7976 44.3097 31.217 42.8903 31.217 41.1456V39.2827C31.8638 38.703 32.2717 37.8618 32.2717 36.9269V36.6961C32.2717 35.298 32.8122 33.9217 33.7176 33.0145C35.5057 31.2224 36.4905 28.8413 36.4905 26.3097C36.4905 20.2573 30.8817 15.6476 24.7284 17.0819ZM29.1077 41.1456C29.1077 41.7272 28.6345 42.2003 28.053 42.2003H25.9436C25.362 42.2003 24.8889 41.7272 24.8889 41.1456V40.0909H29.1077V41.1456ZM32.2243 31.5245C30.9139 32.8377 30.1623 34.7227 30.1623 36.6961V36.9269C30.1623 37.5084 29.6892 37.9816 29.1077 37.9816H24.8889C24.3073 37.9816 23.8342 37.5084 23.8342 36.9269V36.7003C23.8342 34.6964 23.1035 32.8306 21.8294 31.5812C19.9387 29.7271 19.1991 27.0466 19.8507 24.4107C20.4923 21.8157 22.595 19.7452 25.2074 19.1362C30.0359 18.0103 34.3811 21.6148 34.3811 26.3097C34.3811 28.2787 33.6151 30.1307 32.2243 31.5245Z" fill="white" />
                              <path d="M18.7953 16.6162L15.8122 13.6331C15.4004 13.2212 14.7325 13.2212 14.3206 13.6331C13.9087 14.045 13.9087 14.7128 14.3206 15.1247L17.3038 18.1078C17.7156 18.5196 18.3835 18.5196 18.7953 18.1078C19.2072 17.6959 19.2072 17.0281 18.7953 16.6162Z" fill="white" />
                              <path d="M14.3438 25.2559H10.0547C9.47222 25.2559 9 25.7281 9 26.3105C9 26.893 9.47222 27.3652 10.0547 27.3652H14.3438C14.9262 27.3652 15.3984 26.893 15.3984 26.3105C15.3984 25.7281 14.9262 25.2559 14.3438 25.2559Z" fill="white" />
                              <path d="M43.9453 25.2559H39.6562C39.0738 25.2559 38.6016 25.7281 38.6016 26.3105C38.6016 26.893 39.0738 27.3652 39.6562 27.3652H43.9453C44.5278 27.3652 45 26.893 45 26.3105C45 25.7281 44.5278 25.2559 43.9453 25.2559Z" fill="white" />
                              <path d="M39.6781 13.6331C39.2664 13.2212 38.5986 13.2212 38.1866 13.6331L35.2034 16.6162C34.7916 17.028 34.7916 17.6959 35.2034 18.1078C35.6153 18.5196 36.2831 18.5196 36.695 18.1078L39.6781 15.1247C40.09 14.7129 40.09 14.045 39.6781 13.6331Z" fill="white" />
                              <path d="M27 8.31055C26.4175 8.31055 25.9453 8.78277 25.9453 9.36523V13.6543C25.9453 14.2368 26.4175 14.709 27 14.709C27.5825 14.709 28.0547 14.2368 28.0547 13.6543V9.36523C28.0547 8.78277 27.5825 8.31055 27 8.31055Z" fill="white" />
                              <path d="M26.9987 21.0371C26.5652 21.0371 26.1235 21.0891 25.6868 21.1914C23.8682 21.6159 22.3457 23.1129 21.8984 24.9165C21.7582 25.4818 22.1028 26.0538 22.6682 26.194C23.2336 26.3342 23.8055 25.9895 23.9457 25.4243C24.2032 24.3866 25.1162 23.4907 26.1671 23.2453C26.4471 23.1797 26.7269 23.1465 26.9987 23.1465C27.5812 23.1465 28.0534 22.6743 28.0534 22.0918C28.0534 21.5093 27.5812 21.0371 26.9987 21.0371Z" fill="white" />
                            </g>
                            <defs>
                              <clipPath id="clip0_17515_8861">
                                <rect width="36" height="36" fill="white" transform="translate(9 8.31055)" />
                              </clipPath>
                            </defs>
                          </svg>
                        </div>
                        <h2 className="m-0">Our Approach</h2>
                        <ul className="p-0">
                          <li>
                            Proven templates, grammar refinement, and summarizing strategies to make every word count.
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                  <div
                    className="tab-pane fade show active"
                    id="speak-tab-pane"
                    role="tabpanel"
                    aria-labelledby="speak-tab"
                    tabIndex="0"
                  >
                    <div className="lets-coaching-tab-cards">

                      <div className="lets-coaching-tab-left-card">
                        <div className="card-img">
                          <svg width="54" height="52" viewBox="0 0 54 52" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <rect width="54" height="52" rx="16" fill="#0286FF" />
                            <g clip-path="url(#clip0_17515_8851)">
                              <path d="M39.7308 13.5798C36.3328 10.1819 31.8116 8.31055 27 8.31055C22.1884 8.31055 17.6672 10.1819 14.2692 13.5798C10.8713 16.9776 9 21.4989 9 26.3105C9 31.1222 10.8713 35.6434 14.2692 39.0413C17.6671 42.4393 22.1884 44.3105 27 44.3105C31.8116 44.3105 36.3328 42.4392 39.7308 39.0413C43.1287 35.6435 45 31.1222 45 26.3105C45 21.4989 43.1287 16.9777 39.7308 13.5798ZM27 42.0837C18.3026 42.0837 11.2268 35.0079 11.2268 26.3105C11.2268 17.6132 18.3026 10.5374 27 10.5374C35.6974 10.5374 42.7732 17.6132 42.7732 26.3105C42.7732 35.0079 35.6974 42.0837 27 42.0837Z" fill="white" />
                              <path d="M35.7497 17.561C33.4143 15.2257 30.3069 13.9395 27.0001 13.9395C23.6932 13.9395 20.5858 15.2256 18.2504 17.561C15.915 19.8964 14.6289 23.0037 14.6289 26.3106C14.6289 29.6175 15.915 32.7248 18.2504 35.0602C20.5858 37.3956 23.6932 38.6818 27.0001 38.6818C30.3069 38.6818 33.4143 37.3956 35.7497 35.0602C38.0851 32.7248 39.3712 29.6175 39.3712 26.3106C39.3712 23.0037 38.0851 19.8964 35.7497 17.561ZM27.0001 36.455C21.4065 36.455 16.8557 31.9042 16.8557 26.3106C16.8557 20.717 21.4065 16.1663 27.0001 16.1663C32.5936 16.1663 37.1444 20.717 37.1444 26.3106C37.1444 31.9042 32.5936 36.455 27.0001 36.455Z" fill="white" />
                              <path d="M27.0001 19.5684C23.2823 19.5684 20.2578 22.593 20.2578 26.3106C20.2578 30.0283 23.2823 33.0528 27.0001 33.0528C30.7178 33.0528 33.7423 30.0283 33.7423 26.3106C33.7423 22.593 30.7178 19.5684 27.0001 19.5684ZM27.0001 30.826C24.5103 30.826 22.4846 28.8004 22.4846 26.3106C22.4846 23.8208 24.5103 21.7952 27.0001 21.7952C29.4898 21.7952 31.5155 23.8208 31.5155 26.3106C31.5155 28.8004 29.4898 30.826 27.0001 30.826Z" fill="white" />
                            </g>
                            <defs>
                              <clipPath id="clip0_17515_8851">
                                <rect width="36" height="36" fill="white" transform="translate(9 8.31055)" />
                              </clipPath>
                            </defs>
                          </svg>


                        </div>
                        <h2 className="m-0">What It Tests</h2>
                        <ul className="p-0">
                          <li>
                            Pronunciation, fluency, and verbal clarity.
                          </li>
                        </ul>
                      </div>
                      <div className="lets-coaching-tab-right-card">
                        <div className="card-img">
                          <svg width="54" height="52" viewBox="0 0 54 52" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <rect width="54" height="52" rx="16" fill="#0286FF" />
                            <g clip-path="url(#clip0_17515_8861)">
                              <path d="M24.7284 17.0819C21.3516 17.8692 18.6332 20.5472 17.8031 23.9044C16.9704 27.2723 17.9234 30.7051 20.3526 33.0873C21.2118 33.93 21.7248 35.2806 21.7248 36.7003V36.9269C21.7248 37.8618 22.1327 38.703 22.7795 39.2827V41.1456C22.7795 42.8903 24.1989 44.3097 25.9436 44.3097H28.053C29.7976 44.3097 31.217 42.8903 31.217 41.1456V39.2827C31.8638 38.703 32.2717 37.8618 32.2717 36.9269V36.6961C32.2717 35.298 32.8122 33.9217 33.7176 33.0145C35.5057 31.2224 36.4905 28.8413 36.4905 26.3097C36.4905 20.2573 30.8817 15.6476 24.7284 17.0819ZM29.1077 41.1456C29.1077 41.7272 28.6345 42.2003 28.053 42.2003H25.9436C25.362 42.2003 24.8889 41.7272 24.8889 41.1456V40.0909H29.1077V41.1456ZM32.2243 31.5245C30.9139 32.8377 30.1623 34.7227 30.1623 36.6961V36.9269C30.1623 37.5084 29.6892 37.9816 29.1077 37.9816H24.8889C24.3073 37.9816 23.8342 37.5084 23.8342 36.9269V36.7003C23.8342 34.6964 23.1035 32.8306 21.8294 31.5812C19.9387 29.7271 19.1991 27.0466 19.8507 24.4107C20.4923 21.8157 22.595 19.7452 25.2074 19.1362C30.0359 18.0103 34.3811 21.6148 34.3811 26.3097C34.3811 28.2787 33.6151 30.1307 32.2243 31.5245Z" fill="white" />
                              <path d="M18.7953 16.6162L15.8122 13.6331C15.4004 13.2212 14.7325 13.2212 14.3206 13.6331C13.9087 14.045 13.9087 14.7128 14.3206 15.1247L17.3038 18.1078C17.7156 18.5196 18.3835 18.5196 18.7953 18.1078C19.2072 17.6959 19.2072 17.0281 18.7953 16.6162Z" fill="white" />
                              <path d="M14.3438 25.2559H10.0547C9.47222 25.2559 9 25.7281 9 26.3105C9 26.893 9.47222 27.3652 10.0547 27.3652H14.3438C14.9262 27.3652 15.3984 26.893 15.3984 26.3105C15.3984 25.7281 14.9262 25.2559 14.3438 25.2559Z" fill="white" />
                              <path d="M43.9453 25.2559H39.6562C39.0738 25.2559 38.6016 25.7281 38.6016 26.3105C38.6016 26.893 39.0738 27.3652 39.6562 27.3652H43.9453C44.5278 27.3652 45 26.893 45 26.3105C45 25.7281 44.5278 25.2559 43.9453 25.2559Z" fill="white" />
                              <path d="M39.6781 13.6331C39.2664 13.2212 38.5986 13.2212 38.1866 13.6331L35.2034 16.6162C34.7916 17.028 34.7916 17.6959 35.2034 18.1078C35.6153 18.5196 36.2831 18.5196 36.695 18.1078L39.6781 15.1247C40.09 14.7129 40.09 14.045 39.6781 13.6331Z" fill="white" />
                              <path d="M27 8.31055C26.4175 8.31055 25.9453 8.78277 25.9453 9.36523V13.6543C25.9453 14.2368 26.4175 14.709 27 14.709C27.5825 14.709 28.0547 14.2368 28.0547 13.6543V9.36523C28.0547 8.78277 27.5825 8.31055 27 8.31055Z" fill="white" />
                              <path d="M26.9987 21.0371C26.5652 21.0371 26.1235 21.0891 25.6868 21.1914C23.8682 21.6159 22.3457 23.1129 21.8984 24.9165C21.7582 25.4818 22.1028 26.0538 22.6682 26.194C23.2336 26.3342 23.8055 25.9895 23.9457 25.4243C24.2032 24.3866 25.1162 23.4907 26.1671 23.2453C26.4471 23.1797 26.7269 23.1465 26.9987 23.1465C27.5812 23.1465 28.0534 22.6743 28.0534 22.0918C28.0534 21.5093 27.5812 21.0371 26.9987 21.0371Z" fill="white" />
                            </g>
                            <defs>
                              <clipPath id="clip0_17515_8861">
                                <rect width="36" height="36" fill="white" transform="translate(9 8.31055)" />
                              </clipPath>
                            </defs>
                          </svg>

                        </div>
                        <h2 className="m-0">Our Approach</h2>
                        <ul className="p-0">
                          <li>
                            Confidence-building exercises, AI-assisted pronunciation tools, and fluency-enhancing techniques.
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="row master-all-footer">
                <div className="col-md-12 text-center">
                  <Link className="primary-btn" to="/contact">
                    <span className="btn-inner">
                      GET READY TO MASTER EVERY PTE SECTION
                      <img
                        src="/images/web-new-images/right-arrow.svg"
                        alt="Register Now"
                      />
                    </span>
                  </Link>
                </div>
              </div>
            </div>
          </div>

          <TestSection data={testData} bgColor={'linear-gradient(#0D1830 0%,#0D1830 50%,#7F56D9 100%)'} />

          {/* What's Included in Your Video Courses Access */}
          <div className="vc-included-section">
            {/* Top row: Title + CTA */}
            <div className="vc-included-top">
              <div className="vc-included-top__left">
                <h2 className="vc-included-top__title FS40FW600">
                  What's Included in Your<br />
                  <span className="green-text">Video Courses Access</span>
                </h2>
              </div>
              <div className="vc-included-top__right">
                <p className="vc-included-top__desc quote-para FS18FW400 F-600">
                  Every secret, every strategy, every technique – nothing held back.
                </p>
                <ButtonComp btnText="Unlock The Complete System" link="/auth/register" />
              </div>
            </div>

            {/* Bottom row: Image + Features */}
            <div className="vc-included-bottom">
              {/* Left: Image */}
              <div className="vc-included-bottom__left">
                <div className="vc-included-bottom__image">
                  <img src={AsianStudent} alt="PTE Video Course Access" style={{ objectFit: "fill" }} />
                </div>
              </div>

              {/* Right: Features card */}
              <div className="vc-included-bottom__right">
                <div className="vc-included-bottom__feature-item">
                  <div className="vc-included-bottom__feature-header">
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M20 6L9 17L4 12" stroke="#94C23C" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                    </svg>
                    <h4 className="FS20FW500 F-600">Detailed Task Insights</h4>
                  </div>
                  <p className="quote-para FS16FW500">Comprehensive video modules breaking down each PTE task type with surgical precision. Understand not just what to do, but why it works and how to optimize your approach.</p>
                </div>

                <div className="vc-included-bottom__feature-item">
                  <div className="vc-included-bottom__feature-header">
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M20 6L9 17L4 12" stroke="#94C23C" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                    </svg>
                    <h4 className="FS20FW500 F-600">Exam Strategies</h4>
                  </div>
                  <p className="quote-para FS16FW500">Master Varun's personal strategies tailored to each section. These are the exact mental frameworks and tactical approaches he uses to achieve perfect scores consistently.</p>
                </div>

                <div className="vc-included-bottom__feature-item">
                  <div className="vc-included-bottom__feature-header">
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M20 6L9 17L4 12" stroke="#94C23C" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                    </svg>
                    <h4 className="FS20FW500 F-600">Varun Dhawan's Personal Expertise</h4>
                  </div>
                  <p className="quote-para FS16FW500">Access insights and strategies that money can't buy elsewhere – the accumulated wisdom of Australia's most successful PTE practitioner.</p>
                </div>

                <div className="vc-included-bottom__feature-item">
                  <div className="vc-included-bottom__feature-header">
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M20 6L9 17L4 12" stroke="#94C23C" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                    </svg>
                    <h4 className="FS20FW500 F-600">Performance Optimization</h4>
                  </div>
                  <p className="quote-para FS16FW500">Learn how to identify your weaknesses, optimize your strengths, and calibrate your preparation for maximum score improvement.</p>
                </div>

                <div className="vc-included-bottom__feature-item">
                  <div className="vc-included-bottom__feature-header">
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M20 6L9 17L4 12" stroke="#94C23C" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                    </svg>
                    <h4 className="FS20FW500 F-600">Test Day Mastery</h4>
                  </div>
                  <p className="quote-para FS16FW500">Mental preparation, time management, and the confidence-building techniques that separate good performers from perfect scorers.</p>
                </div>
              </div>
            </div>
          </div>
          {/* Gold Package Hero Section */}
          <div className="vc-gold-hero" ref={sectionRef}>
            <div className="vc-gold-hero__inner">
              {/* Left: Features */}
              <div className="vc-gold-hero__left">
                <div className="vc-gold-hero__header">
                  <h2 className="vc-gold-hero__title FS40FW600">
                    <span className="green-text">The Gold Package</span>
                    <br />
                    Your Gateway To PTE Excellence
                  </h2>
                </div>

                <div className="vc-gold-hero__tagline">
                  <p className="quote-para FS18FW400">Everything you need for PTE success, including exclusive access to Varun's video course.</p>
                </div>

                <div className="vc-gold-hero__features">
                  <div className="vc-gold-hero__features-scroll">
                    {[
                      { title: "Unlimited AI -Scoring", desc: "Perfect your responses with unlimited access to our advanced AI scoring system across all question types." },
                      { title: "Complete Question Bank", desc: "Practice with our comprehensive database of exam questions covering every possible scenario." },
                      { title: "Latest Templates & Predictions", desc: "Stay ahead with constantly updated templates and prediction files based on recent exam patterns." },
                      { title: "Unlimited Mock Tests", desc: "Take as many sectional, full-length, and comprehensive mock tests as you need to build unshakeable confidence." },
                      { title: "Reading Explanation Videos", desc: "Master complex reading tasks with detailed explanation videos that clarify every aspect." },
                    ].map((feature, idx) => (
                      <div className="vc-gold-hero__feature" key={idx}>
                        <div className="vc-gold-hero__feature-header">
                          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M4 12.6111L8.92308 17.5L20 6.5" stroke="#94C23C" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                          </svg>
                          <h3 className="vc-gold-hero__feature-title FS20FW500 F-600">{feature.title}</h3>
                        </div>
                        <p className="vc-gold-hero__feature-desc quote-para FS16FW500">{feature.desc}</p>
                      </div>
                    ))}
                  </div>
                </div>
              </div>

              {/* Right: Pricing */}
              <div className="vc-gold-hero__right">
                {/* Pricing Title */}
                <h3 className="vc-gold-hero__pricing-title FS24FW500 F-600">Choose Your Gold Package Duration</h3>

                {/* PTE Academic / Core Tabs */}
                <div className="vc-gold-hero__pricing-tabs">
                  <ul className="nav nav-tabs" role="tablist">
                    <li className="nav-item" role="presentation">
                      <button
                        className={`nav-link ${activeTab === "la_acedemics_tab" ? "active" : ""}`}
                        onClick={() => handleTabClick("la_acedemics_tab")}
                        type="button"
                      >
                        PTE Academic
                      </button>
                    </li>
                    <li className="nav-item" role="presentation">
                      <button
                        className={`nav-link ${activeTab === "la_pte_tab" ? "active" : ""}`}
                        onClick={() => handleTabClick("la_pte_tab")}
                        type="button"
                      >
                        PTE Core
                      </button>
                    </li>
                  </ul>
                </div>

                {/* Plan Cards */}
                <div className="vc-gold-hero__plans">
                  {(activeTab === "la_acedemics_tab" ? plans : corePlans).map((plan, index) => {
                    const displayPrice =
                      selectedPaymentMethod === "upi"
                        ? plan.razorpay_price
                        : plan.price;
                    const isBestSeller = plan.duration === 2;
                    const isMostSavings = plan.duration === 3;
                    const isStandard = plan.duration === 1;

                    const isSelected = selectedPlanId === plan.id;

                    return (
                      <div
                        className={`vc-gold-hero__plan ${isSelected ? "vc-gold-hero__plan--active" : ""}`}
                        key={plan.id}
                        onClick={() => {
                          setSelectedPlanId(plan.id);
                          setShowPaymentOptions(false);
                          setSelectedPaymentMethod("");
                        }}
                      >
                        <div className="vc-gold-hero__plan-left">
                          <div className={`vc-gold-hero__plan-radio ${isSelected ? "vc-gold-hero__plan-radio--selected" : ""}`}>
                            {isSelected && <span className="vc-gold-hero__plan-radio-dot"></span>}
                          </div>
                          <div className="vc-gold-hero__plan-info">
                            <span className="vc-gold-hero__plan-duration">{plan.duration} Month{plan.duration > 1 ? "s" : ""}</span>
                            {!isStandard && plan.discount && (
                              <span className="vc-gold-hero__plan-discount">{plan.discount}% OFF</span>
                            )}
                          </div>
                        </div>
                        <div className="vc-gold-hero__plan-right">
                          <span className={`vc-gold-hero__plan-badge ${isSelected ? "vc-gold-hero__plan-badge--green" : ""}`}>
                            {isStandard ? "STANDARD" : isBestSeller ? "BEST SELLER" : "MOST SAVINGS"}
                          </span>
                          <span className="vc-gold-hero__plan-price">
                            {country === "IN" ? `INR ${displayPrice}` : `AUD $${displayPrice}`}
                          </span>
                        </div>
                      </div>
                    );
                  })}
                </div>

                {/* CTA Button */}
                <div className="vc-gold-hero__cta">
                  <button
                    className="vc-gold-hero__upgrade-btn"
                    onClick={handleUpgradeClick}
                  >
                    Upgrade To Gold Now
                    <img src="/images/web-new-images/right-arrow.svg" alt="LA" />
                  </button>
                </div>

                {/* Payment Options - shown after clicking Upgrade */}
                {showPaymentOptions && selectedPlanId && (
                  <div className="vc-gold-hero__payment-options">
                    {token && activeSubscription?.length > 0 && (
                      <p className="vc-gold-hero__subscription-warning">You already have an active subscription.</p>
                    )}
                    <div className="vc-gold-hero__payment-row">
                      <div className="vc-gold-hero__payment-select-wrapper">
                        <select
                          className="vc-gold-hero__payment-select"
                          value={selectedPaymentMethod}
                          onChange={(e) => setSelectedPaymentMethod(e.target.value)}
                        >
                          <option value="">Select Payment Method</option>
                          <option value="card">Pay with Card</option>
                          {country === "IN" && <option value="upi">Pay with UPI</option>}
                        </select>
                      </div>
                      {selectedPaymentMethod === "upi" && country === "IN" ? (
                        <RazorPay
                          plan={(activeTab === "la_acedemics_tab" ? plans : corePlans).find((p) => p.id === selectedPlanId)}
                          isLoggedIn={false}
                          redirect={() => {
                            const selectedPlan = (activeTab === "la_acedemics_tab" ? plans : corePlans).find((p) => p.id === selectedPlanId);
                            if (selectedPlan) redirectAfterPayment(selectedPlan);
                          }}
                          activeTab={activeTab}
                        >
                          {(clickHandler) => (
                            <button
                              className="vc-gold-hero__pay-btn"
                              onClick={clickHandler}
                            >
                              Pay Now
                            </button>
                          )}
                        </RazorPay>
                      ) : (
                        <button
                          className="vc-gold-hero__pay-btn"
                          onClick={handlePayClick}
                        >
                          Pay Now
                        </button>
                      )}
                    </div>
                  </div>
                )}

                <p className="vc-gold-hero__cta-note">*Auto-renews. Cancel anytime</p>
              </div>
            </div>
          </div>
          <TestimonialSection
            title={`<span class="hero-title FS40FW600 text-center mb-md-0">What Our <span class="green-text">Video Course </span>Students Says</span>`}
            subtitle="Real results from real students who experienced Varun's training."
            btnText="Join Thousands Of Success Stories"
            btnLink="/auth/register"
            sliderList={sliderList}
          />

          {/* <div className="pc-why-choose vc-why vc-why-wrapper">
            <div className="container">
              <div className="row justify-content-center text-center">
                <div className="col-lg-10">
                  <div className="d-flex justify-content-center mb-3">
                    <span className="wpl-badge gold-badge text-white">WHY VARUN DHAWAN'S</span>
                  </div>
                  <h2 className="primary-heading fw-800 mb-4" style={{ color: '#0d1830', fontSize: '42px', lineHeight: '1.2' }}>
                    VIDEO COURSE IS THE <br /> GAME-CHANGER YOU NEED
                  </h2>

                  <p className="sub-title text-center mx-auto mb-4" style={{ maxWidth: '800px', fontSize: '18px', color: '#4b5563' }}>
                    Most PTE courses are taught by instructors who have simply passed the exam. Varun Dhawan has conquered it - achieving the maximum possible score not once, but 12 times.
                  </p>
                  <p className="sub-title text-center mx-auto mb-5" style={{ maxWidth: '800px', fontSize: '18px', color: '#4b5563' }}>
                    This course doesn't just teach PTE strategies - it reveals the mindset, approach, and precise techniques of someone who has mastered every aspect of the exam.
                  </p>
                </div>
              </div>

              <div className="row g-4">
                <div className="col-md-6 mb-4">
                  <div className="feature-card-green d-flex flex-row align-items-start">
                    <div className="icon-circle">
                      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M20 6L9 17L4 12" stroke="#4DAF4E" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                      </svg>
                    </div>
                    <div>
                      <h3>Expert Instruction</h3>
                      <p>Learn from 6+ years of teaching excellence and unparalleled PTE mastery. Varun's personal journey from student to perfect scorer to Australia's most trusted PTE trainer.</p>
                    </div>
                  </div>
                </div>

                <div className="col-md-6 mb-4">
                  <div className="feature-card-green d-flex flex-row align-items-start">
                    <div className="icon-circle">
                      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M20 6L9 17L4 12" stroke="#4DAF4E" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                      </svg>
                    </div>
                    <div>
                      <h3>Proven Strategies</h3>
                      <p>Access the exact methods that have consistently delivered 79+ scores. These aren't theoretical approaches - they're battle-tested techniques refined through thousands of successful students.</p>
                    </div>
                  </div>
                </div>

                <div className="col-md-6 mb-4">
                  <div className="feature-card-green d-flex flex-row align-items-start">
                    <div className="icon-circle">
                      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M20 6L9 17L4 12" stroke="#4DAF4E" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                      </svg>
                    </div>
                    <div>
                      <h3>Comprehensive Coverage</h3>
                      <p>Master every single PTE task with detailed video tutorials that leave nothing to chance. From basic understanding to advanced optimization techniques.</p>
                    </div>
                  </div>
                </div>

                <div className="col-md-6 mb-4">
                  <div className="feature-card-green d-flex flex-row align-items-start">
                    <div className="icon-circle">
                      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M20 6L9 17L4 12" stroke="#4DAF4E" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                      </svg>
                    </div>
                    <div>
                      <h3>Exclusive Access</h3>
                      <p>Available only with our Gold package, ensuring you receive the highest caliber instruction reserved for our most committed students.</p>
                    </div>
                  </div>
                </div>
              </div>

              <div className="vc-bottom-banner">
                <div className="banner-text">
                  When you learn from the best, there's no room for error.
                </div>
                <Link className="primary-btn bg-green-btn" to="/auth/register">
                  <span className="btn-inner text-white fw-700">
                    UNLOCK VARUN'S EXPERTISE
                    <svg className="ms-2" width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M1.16699 7.00008H12.8337M12.8337 7.00008L7.00033 1.16675M12.8337 7.00008L7.00033 12.8334" stroke="white" strokeWidth="1.66667" strokeLinecap="round" strokeLinejoin="round" />
                    </svg>
                  </span>
                </Link>
              </div>
            </div>
          </div> */}



          {/* <div className="pte-campus mt-0 vc-pte-campus">
            <div className="container">
              <div className="row align-items-center">
                <div className="col-lg-6 text-center">
                  <h2 className="primary-heading">
                    <span className="wpl-badge text-white mb-4">
                      WHAT'S INCLUDED
                    </span>
                    <br />
                    IN YOUR VIDEO
                    <br />
                    COURSE ACCESS
                  </h2>
                  <p className="text-uppercase">
                    Every secret, every strategy, every
                    <br />
                    technique - nothing held back.
                  </p>
                  <div className="text-center">
                    <Link to="/auth/register" className="primary-btn">
                      UNLOCK THE COMPLETE SYSTEM
                      <img
                        src="/images/web-new-images/right-arrow.svg"
                        alt="Register Now"
                      />
                    </Link>
                  </div>
                </div>
                <div className="col-lg-6">
                  <div className="pte-campus-list mb-0 mt-4 mt-lg-0">
                    <ul>
                      <li>
                        <h3>
                          <svg
                            width="40"
                            height="41"
                            viewBox="0 0 40 41"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <rect
                              y="0.301758"
                              width="40"
                              height="40"
                              rx="20"
                              fill="#48A75C"
                              fillOpacity="0.12"
                            />
                            <path
                              d="M28 14.3018L17 25.3018L12 20.3018"
                              stroke="#48A75C"
                              strokeWidth="1.8"
                              strokeLinecap="round"
                              strokeLinejoin="round"
                            />
                          </svg>{" "}
                          DETAILED TASK INSIGHTS
                        </h3>
                        <p>
                          Comprehensive video modules breaking down each PTE
                          task type with surgical precision. Understand not just
                          what to do, but why it works and how to optimize your
                          approach.
                        </p>
                      </li>
                      <li>
                        <h3>
                          <svg
                            width="40"
                            height="41"
                            viewBox="0 0 40 41"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <rect
                              y="0.301758"
                              width="40"
                              height="40"
                              rx="20"
                              fill="#48A75C"
                              fillOpacity="0.12"
                            />
                            <path
                              d="M28 14.3018L17 25.3018L12 20.3018"
                              stroke="#48A75C"
                              strokeWidth="1.8"
                              strokeLinecap="round"
                              strokeLinejoin="round"
                            />
                          </svg>{" "}
                          ONE-ON-ONE SESSIONS
                        </h3>
                        <p>
                          Master Varun's personal strategies tailored to each
                          section. These are the exact mental frameworks and
                          tactical approaches he uses to achieve perfect scores
                          consistently.
                        </p>
                      </li>
                      <li>
                        <h3>
                          <svg
                            width="40"
                            height="41"
                            viewBox="0 0 40 41"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <rect
                              y="0.301758"
                              width="40"
                              height="40"
                              rx="20"
                              fill="#48A75C"
                              fillOpacity="0.12"
                            />
                            <path
                              d="M28 14.3018L17 25.3018L12 20.3018"
                              stroke="#48A75C"
                              strokeWidth="1.8"
                              strokeLinecap="round"
                              strokeLinejoin="round"
                            />
                          </svg>{" "}
                          VARUN DHAWAN'S PERSONAL EXPERTISE
                        </h3>
                        <p>
                          Access insights and strategies that money can't buy
                          elsewhere - the accumulated wisdom of Australia's most
                          successful PTE practitioner.
                        </p>
                      </li>
                      <li>
                        <h3>
                          <svg
                            width="40"
                            height="41"
                            viewBox="0 0 40 41"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <rect
                              y="0.301758"
                              width="40"
                              height="40"
                              rx="20"
                              fill="#48A75C"
                              fillOpacity="0.12"
                            />
                            <path
                              d="M28 14.3018L17 25.3018L12 20.3018"
                              stroke="#48A75C"
                              strokeWidth="1.8"
                              strokeLinecap="round"
                              strokeLinejoin="round"
                            />
                          </svg>{" "}
                          PERFORMANCE OPTIMIZATION
                        </h3>
                        <p>
                          Learn how to identify your weaknesses, optimize your
                          strengths, and calibrate your preparation for maximum
                          score improvement.
                        </p>
                      </li>
                      <li>
                        <h3>
                          <svg
                            width="40"
                            height="41"
                            viewBox="0 0 40 41"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <rect
                              y="0.301758"
                              width="40"
                              height="40"
                              rx="20"
                              fill="#48A75C"
                              fillOpacity="0.12"
                            />
                            <path
                              d="M28 14.3018L17 25.3018L12 20.3018"
                              stroke="#48A75C"
                              strokeWidth="1.8"
                              strokeLinecap="round"
                              strokeLinejoin="round"
                            />
                          </svg>{" "}
                          TEST DAY MASTERY
                        </h3>
                        <p>
                          Mental preparation, time management, and the
                          confidence-building techniques that separate good
                          performers from perfect scorers.
                        </p>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div> */}



          {/* <FameWallNaati show={false} />
          <CrackedCodeSlider
            title={`<span className="fw-700">WHAT OUR video</span> <br className="d-block" /><span className="wpl-badge pte-naati-badge text-white">COURSE STUDENTS SAY</span>`}
            subtitle={`Real results from real students who experienced Varun's training.`} /> */}



          <SkillAreas
            className={"vc-gold-why-section"}
            leftSection={false}
            skillAreaTitle={() => (
              <p className="top-section-text mb-0 text-center w-100 FS40FW600">
                Why <span className="green-text">Gold Package Students </span>
                Archive Higher Scores
              </p>
            )}
            lifestyleCards={goldWhyCards}
            btnText2={"Experience Our Proven Approach"}
            skillBottomtitle={"The difference between good preparation and perfect preparation."}
          />
          {/* OLD WHY GOLD SECTION removed */}
          {/* list4-old
                        <span className="list-counting">
                          <svg
                            width="30"
                            height="31"
                            viewBox="0 0 30 31"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M19.9769 10.6239V6.89056L23.7102 3.15723L24.9546 5.64612L27.4435 6.89056L23.7102 10.6239H19.9769ZM19.9769 10.6239L14.9991 15.6016M27.4436 15.6017C27.4436 22.4746 21.872 28.0461 14.9991 28.0461C8.12626 28.0461 2.55469 22.4746 2.55469 15.6017C2.55469 8.72879 8.12626 3.15723 14.9991 3.15723M21.2214 15.6017C21.2214 19.0381 18.4356 21.8239 14.9991 21.8239C11.5627 21.8239 8.77691 19.0381 8.77691 15.6017C8.77691 12.1652 11.5627 9.37945 14.9991 9.37945"
                              stroke="#FFB02C"
                              strokeWidth="1.86667"
                              strokeLinecap="round"
                              strokeLinejoin="round"
                            />
                          </svg>
                        </span>
                        <div>
                          <h3>PRECISION TRAINING</h3>
                          <p>
                            Learn with surgical precision rather than generic
                            advice. Every technique is calibrated for maximum
                            score impact.
                          </p>
                        </div>
                      </li>
                      <li className="list3">
                        <span className="list-counting">
                          <svg
                            width="30"
                            height="31"
                            viewBox="0 0 30 31"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M26.2008 26.8019H5.79189C5.09494 26.8019 4.74646 26.8019 4.48026 26.6662C4.2461 26.5469 4.05573 26.3565 3.93642 26.1224C3.80078 25.8562 3.80078 25.5077 3.80078 24.8107V4.40186M26.2008 9.37963L19.4381 16.1423C19.1917 16.3887 19.0685 16.512 18.9264 16.5581C18.8014 16.5987 18.6668 16.5987 18.5418 16.5581C18.3998 16.512 18.2766 16.3887 18.0302 16.1423L15.7047 13.8169C15.4583 13.5705 15.3351 13.4473 15.1931 13.4012C15.0681 13.3605 14.9335 13.3605 14.8085 13.4012C14.6664 13.4473 14.5432 13.5705 14.2968 13.8169L8.77856 19.3352M26.2008 9.37963H21.223M26.2008 9.37963V14.3574"
                              stroke="#48A75C"
                              strokeWidth="1.86667"
                              strokeLinecap="round"
                              strokeLinejoin="round"
                            />
                          </svg>
                        </span>
                        <div>
                          <h3>PROVEN METHODOLOGY</h3>
                          <p>
                            Follow the exact system that has guided 50,000+
                            students to success, refined through years of
                            teaching excellence.
                          </p>
                        </div>
                      </li>
                      <li className="list6">
                        <span className="list-counting">
                          <svg
                            width="30"
                            height="31"
                            viewBox="0 0 30 31"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M3.18059 11.8685H26.825M12.5139 4.40186L10.025 11.8685L15.0028 26.1796L19.9806 11.8685L17.4917 4.40186M15.7676 25.8841L26.9161 12.5059C27.1051 12.2791 27.1996 12.1658 27.2357 12.0392C27.2675 11.9276 27.2675 11.8094 27.2357 11.6978C27.1996 11.5713 27.1051 11.4579 26.9161 11.2312L21.5235 4.76007C21.4138 4.6284 21.359 4.56256 21.2917 4.51523C21.2321 4.4733 21.1656 4.44215 21.0953 4.42322C21.0158 4.40186 20.9301 4.40186 20.7587 4.40186H9.24688C9.07548 4.40186 8.98978 4.40186 8.91037 4.42322C8.84 4.44215 8.77351 4.4733 8.71392 4.51523C8.64666 4.56256 8.5918 4.6284 8.48207 4.76007L3.08948 11.2312C2.90054 11.4579 2.80607 11.5713 2.76997 11.6978C2.73814 11.8094 2.73814 11.9276 2.76997 12.0392C2.80607 12.1658 2.90054 12.2791 3.08948 12.5059L14.238 25.8841C14.5007 26.1993 14.632 26.3569 14.7892 26.4143C14.9271 26.4647 15.0785 26.4647 15.2164 26.4143C15.3736 26.3569 15.505 26.1993 15.7676 25.8841Z"
                              stroke="#0286FF"
                              strokeWidth="1.86667"
                              strokeLinecap="round"
                              strokeLinejoin="round"
                            />
                          </svg>
                        </span>
                        <div>
                          <h3>Premium Support</h3>
                          <p>
                            Gold package subscribers receive priority access to
                            updates, new content, and advanced training
                            materials.
                          </p>
                        </div>
                      </li>
                      <li className="list7">
                        <span className="list-counting">
                          <svg
                            width="30"
                            height="31"
                            viewBox="0 0 30 31"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M9.86008 19.9074L8.77908 28.0461L14.4891 24.6201C14.6753 24.5084 14.7684 24.4525 14.8678 24.4307C14.9558 24.4114 15.0468 24.4114 15.1348 24.4307C15.2342 24.4525 15.3273 24.5084 15.5135 24.6201L21.2235 28.0461L20.1432 19.9038M20.5091 5.95583C20.7013 6.42066 21.0702 6.79013 21.5347 6.98303L23.1635 7.65774C23.6284 7.85029 23.9977 8.21962 24.1902 8.68448C24.3828 9.14934 24.3828 9.67165 24.1902 10.1365L23.516 11.7642C23.3234 12.2293 23.3231 12.7522 23.5166 13.217L24.1897 14.8442C24.2851 15.0745 24.3343 15.3213 24.3343 15.5705C24.3344 15.8198 24.2853 16.0666 24.1899 16.2968C24.0945 16.5271 23.9547 16.7363 23.7784 16.9125C23.6022 17.0887 23.3929 17.2285 23.1626 17.3238L21.535 17.998C21.0702 18.1902 20.7007 18.5592 20.5078 19.0237L19.8331 20.6526C19.6406 21.1174 19.2713 21.4868 18.8064 21.6793C18.3416 21.8719 17.8193 21.8719 17.3544 21.6793L15.7268 21.0051C15.2619 20.813 14.7398 20.8134 14.2752 21.0062L12.6464 21.6799C12.1818 21.872 11.66 21.8719 11.1955 21.6795C10.731 21.4871 10.3619 21.1182 10.1693 20.6538L9.49437 19.0244C9.30218 18.5596 8.93328 18.1901 8.46876 17.9973L6.83992 17.3225C6.37528 17.1301 6.00607 16.761 5.81346 16.2964C5.62084 15.8318 5.62058 15.3097 5.81273 14.8449L6.48694 13.2172C6.67901 12.7523 6.67861 12.2302 6.48584 11.7656L5.81261 10.1356C5.71716 9.90532 5.66801 9.65853 5.66797 9.40928C5.66793 9.16004 5.717 8.91323 5.81238 8.68296C5.90775 8.45269 6.04757 8.24348 6.22383 8.06726C6.40009 7.89105 6.60935 7.7513 6.83964 7.65599L8.46731 6.98176C8.93172 6.78973 9.30096 6.42128 9.49399 5.95728L10.1687 4.32838C10.3612 3.86352 10.7305 3.49419 11.1954 3.30164C11.6602 3.10909 12.1825 3.10909 12.6474 3.30164L14.275 3.97587C14.7399 4.16795 15.262 4.16755 15.7266 3.97478L17.3561 3.30269C17.8209 3.11024 18.343 3.11028 18.8078 3.3028C19.2725 3.49531 19.6418 3.86453 19.8344 4.32927L20.5093 5.95865L20.5091 5.95583Z"
                              stroke="#FFB02C"
                              strokeWidth="1.86667"
                              strokeLinecap="round"
                              strokeLinejoin="round"
                            />
                          </svg>
                        </span>
                        <div>
                          <h3>Results Guarantee</h3>
                          <p>
                            Join the 94% of Gold package students who achieve
                            their target scores within their subscription
                            period.
                          </p>
                        </div>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
            <div className="container">
              <div className="row justify-content-center my-5">
                <div className="col-lg-8">
                  <div className="video-container" style={{ position: 'relative', paddingBottom: '56.25%', height: 0, overflow: 'hidden', borderRadius: '12px', boxShadow: '0 4px 6px rgba(0,0,0,0.1)' }}>
                    <video
                      controls
                      // poster={VideoCourseImage}
                      style={{ position: 'absolute', top: 0, left: 0, width: '100%', height: '100%', objectFit: 'cover' }}
                    >
                      <source src={CourseVideo} type="video/mp4" />
                      Your browser does not support the video tag.
                    </video>
                  </div>
                </div>
              </div>
            </div>
          </div>
          END OLD SECTION */}

          {/* Start Your Journey Section - New Design */}
          <div className="vc-journey-section">
            <div className="custom-container py-5">
              <div className="row align-items-center justify-content-between content-image-section">
                <div className="col-lg-5 col-md-12 mb-4 mb-lg-0">
                  <p className="top-section-text FS40FW600">
                    Start Your Journey To <em className="green-text">PTE<br />Success Today</em>
                  </p>
                  <div className="quote-box mt-3 FS18FW400 black">
                    Stop settling for average preparation. Demand excellence.
                  </div>
                  <p className="mt-3 FS17FW500 quote-para">
                    The difference between scoring 65 and scoring 90 isn't just
                    practice – it's learning from someone who has mastered the
                    exam at the highest possible level.
                  </p>
                  <p className="mt-3 FS17FW500 quote-para">
                    Varun Dhawan's exclusive video course represents your direct
                    access to perfection. These aren't just lessons – they're the
                    accumulated wisdom of Australia's most successful PTE trainer,
                    distilled into the ultimate learning experience.
                  </p>
                  <ButtonComp btnText="Upgrade To Gold Package Now" link="/auth/register" className="mt-2" />
                </div>
                <div className="col-lg-6 col-md-12 cis-image-col">
                  <img className="cis-image immigration-test-img" src={ImmigrationSecond} alt="PTE Student Studying" />
                </div>
              </div>

              {/* Journey Begins */}
              <h3 className="vc-journey-section__begins-title FS24FW500 F-600 mt-5">
                Your PTE Success Journey Begins Here:
              </h3>
              <div className="row g-4">
                {styleCard2.map((card, index) => (
                  <SkillCard card={card} index={index} key={index} color={"black"} />
                ))}
              </div>

              {/* Bottom CTA */}
              <p className="vc-journey-section__bottom-text FS20FW500 F-600 text-center mt-4">
                Don't just prepare for PTE. Master it.
              </p>
            </div>
          </div>

          {/* PTE App Download Section */}
          {/* <PteAppBanner /> */}
          <AppBannerCustom
            appName="PTE"
            description="PTE PRACTICE"
            mobileImage="/images/web-new-images/HomePageImage/PTE-app-1.png"
            playStoreLink={`${import.meta.env.VITE_PTE_ANDROID_APP_URL}`}
            appStoreLink={`${import.meta.env.VITE_PTE_IOS_APP_URL}`}
          />

          <FaqSection questions={faqQuestions} />

          {/* OLD FAQ SECTION removed - replaced by FaqSection component */}
          {/* <div className="faq-section-old">
                  <div className="accordion-item">
                    <h2 className="accordion-header" id="headingTwo">
                      <button
                        className="accordion-button collapsed"
                        type="button"
                        data-bs-toggle="collapse"
                        data-bs-target="#collapseTwo"
                        aria-expanded="false"
                        aria-controls="collapseTwo"
                      >
                        Can I access the video course without the Gold package?
                      </button>
                    </h2>
                    <div
                      id="collapseTwo"
                      className="accordion-collapse collapse"
                      aria-labelledby="headingTwo"
                      data-bs-parent="#accordionExample"
                    >
                      <div className="accordion-body">
                        Lorem ipsum dolor sit, amet consectetur adipisicing
                        elit. Non, maiores voluptate iste repellat debitis vero
                        nisi cumque nulla aspernatur beatae doloribus facilis
                        cum sapiente nesciunt suscipit vitae sit dolorem autem.
                      </div>
                    </div>
                  </div>
                  <div className="accordion-item">
                    <h2 className="accordion-header" id="headingThree">
                      <button
                        className="accordion-button collapsed"
                        type="button"
                        data-bs-toggle="collapse"
                        data-bs-target="#collapseThree"
                        aria-expanded="false"
                        aria-controls="collapseThree"
                      >
                        How long do I have access to the video course?
                      </button>
                    </h2>
                    <div
                      id="collapseThree"
                      className="accordion-collapse collapse"
                      aria-labelledby="headingThree"
                      data-bs-parent="#accordionExample"
                    >
                      <div className="accordion-body">
                        Lorem ipsum, dolor sit amet consectetur adipisicing
                        elit. Veniam eaque provident dignissimos quos
                        necessitatibus tempora perferendis architecto
                        repellendus ea ex voluptates sed eos iusto in, eveniet
                        voluptatibus, magni ratione ut?
                      </div>
                    </div>
                  </div>
                  <div className="accordion-item">
                    <h2 className="accordion-header" id="headingFour">
                      <button
                        className="accordion-button collapsed"
                        type="button"
                        data-bs-toggle="collapse"
                        data-bs-target="#collapseFour"
                        aria-expanded="false"
                        aria-controls="collapseFour"
                      >
                        Is the content updated regularly?
                      </button>
                    </h2>
                    <div
                      id="collapseFour"
                      className="accordion-collapse collapse"
                      aria-labelledby="headingFour"
                      data-bs-parent="#accordionExample"
                    >
                      <div className="accordion-body">
                        Lorem ipsum, dolor sit amet consectetur adipisicing
                        elit. Veniam eaque provident dignissimos quos
                        necessitatibus tempora perferendis architecto
                        repellendus ea ex voluptates sed eos iusto in, eveniet
                        voluptatibus, magni ratione ut?
                      </div>
                    </div>
                  </div>
                  <div className="accordion-item">
                    <h2 className="accordion-header" id="headingFive">
                      <button
                        className="accordion-button collapsed"
                        type="button"
                        data-bs-toggle="collapse"
                        data-bs-target="#collapseFive"
                        aria-expanded="false"
                        aria-controls="collapseFive"
                      >
                        What if I'm not satisfied with the course?
                      </button>
                    </h2>
                    <div
                      id="collapseFive"
                      className="accordion-collapse collapse"
                      aria-labelledby="headingFive"
                      data-bs-parent="#accordionExample"
                    >
                      <div className="accordion-body">
                        Lorem ipsum, dolor sit amet consectetur adipisicing
                        elit. Veniam eaque provident dignissimos quos
                        necessitatibus tempora perferendis architecto
                        repellendus ea ex voluptates sed eos iusto in, eveniet
                        voluptatibus, magni ratione ut?
                      </div>
                    </div>
                  </div>
                  <div className="accordion-item">
                    <h2 className="accordion-header" id="headingSix">
                      <button
                        className="accordion-button collapsed"
                        type="button"
                        data-bs-toggle="collapse"
                        data-bs-target="#collapseSix"
                        aria-expanded="false"
                        aria-controls="collapseSix"
                      >
                        How much time should I dedicate to the video course?
                      </button>
                    </h2>
                    <div
                      id="collapseSix"
                      className="accordion-collapse collapse"
                      aria-labelledby="headingSix"
                      data-bs-parent="#accordionExample"
                    >
                      <div className="accordion-body">
                        Lorem ipsum, dolor sit amet consectetur adipisicing
                        elit. Veniam eaque provident dignissimos quos
                        necessitatibus tempora perferendis architecto
                        repellendus ea ex voluptates sed eos iusto in, eveniet
                        voluptatibus, magni ratione ut?
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-lg-12 text-center mt-4">
                <Link className="primary-btn" to="/auth/register">
                  <span className="btn-inner">
                    UPGRADE TO GOLD PACKAGE TODAY
                    <img
                      src="/images/web-new-images/right-arrow.svg"
                      alt="Register Now"
                    />
                  </span>
                </Link>
              </div>
            </div>
          END OLD FAQ */}
        </div>
        <Footer />
      </div>
    </React.Fragment>
  );
};

export default VideoCourse;